import { EventHandler, MouseEvent, SetStateAction, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import StandeditorService from "../../services/plan/standeditor.service";
import AuthService from "../../services/auth/auth.service";
import ReactHtmlParser from 'html-react-parser'; 
import './css/cardview.css'
import './css/plan.css'
import './css/planstyle.css'
import standeditorService from "../../services/plan/standeditor.service";
import planService from "../../services/plan/plan.service";

const parse = require('html-react-parser').default;



const LOCAL_STORAGE_POSX = AuthService.getCurrentUser()?.shrt + '_crm-standeditor'  + '-scrollposX' 
const LOCAL_STORAGE_POSY = AuthService.getCurrentUser()?.shrt + '_crm-standeditor'  + '-scrollposY' 





const Cardview = () => {

    const [backgroundImg, setBackgroundImg] = useState("");
    const [hideBackground, setHideBackground] = useState(true)


    const params = useParams();

    var param_id = params.id
    var plan_id = -1;
    if (param_id){
      var tmp_id = parseInt(param_id)
      if (!Number.isNaN(tmp_id)){
        plan_id = tmp_id
      }
  
    }

    const queryParameters = new URLSearchParams(window.location.search)

    var param_v = queryParameters.get("v")
    var param_p = queryParameters.get("p")
    var param_l1 = queryParameters.get("l1")
    var param_l2 = queryParameters.get("l2")
    var param_l2e = queryParameters.get("l2e")
    var param_gns = queryParameters.get("gns")
    var param_p1 = queryParameters.get("p1")
    var param_p2 = queryParameters.get("p2")
    var param_l3 = queryParameters.get("l3")
    var param_l4 = queryParameters.get("l4")
    var param_l5 = queryParameters.get("l5")
    var param_s = queryParameters.get("s")
    var param_p3 = queryParameters.get("p3")
    var param_background = queryParameters.get("background")
    var param_lang = queryParameters.get("lang")
    if (param_lang == null){
        param_lang = 'pl'
    }
   

    const [plan_CONTENT, setContent] = useState('');

    const [plan_NAME, setPlanNAME] = useState('');
    const [plan_DATE, setPlanDate] = useState("");

    const [backgroundPosition, setbackgroundPosition] = useState("left 0px top 0px");
    const [plan_groupId, setPlanGroupID] = useState(0);
    const [plan_modified, setPlanModifiedDate] = useState(0);
    const [plan_width, setPlanWidth] = useState(0);
    const [plan_height, setPlanHeight] = useState(0);
    const [color_wall, setWallColor] = useState("");
    const [color_stand, setStandColor] = useState("");

    const [tc_listingdate, set_tc_listingdate] = useState("");
    const [tc_checkingdate, set_tc_checkingdate] = useState("");

    const [tc_constructiondate, set_tc_constructiondate] = useState("");
    const [tc_componentgraphicsdate, set_tc_componentgraphicsdate] = useState("");

    const [tc_readygraphicsdate, set_tc_readygraphicsdate] = useState("");
    const [tc_componentpresentationdate, set_tc_componentpresentationdate] = useState("");

    const [tc_readypresentationdate, set_tc_readypresentationdate] = useState("");
    const [tc_othercommands, set_tc_othercommands] = useState("");

    const [tc_disassemblystand, set_tc_disassemblystand] = useState("");
    const [tc_insertsdate, set_tc_insertsdate] = useState("");

    const [tc_fairdate, set_tc_fairdate] = useState("");
    const [tc_objectname, set_tc_objectname] = useState("");
    const [tc_objectaddress, set_tc_objectaddress] = useState("");
    const [tc_visitoropeninghours, set_tc_visitoropeninghours] = useState("");
    const [tc_exhibitoropeninghours, set_tc_exhibitoropeninghours] = useState("");

    const [note1, setNote1] = useState("");
    const [note2, setNote2] = useState("");
    const [tc_disassemblybuiltstand, set_tc_disassemblybuiltstand] = useState("");
    const [parkrules, setParkrules] = useState("");
    const [tc_othercomments, set_tc_othercomments] = useState("")

    const [tc_parkmapimage, setParkMapImage] = useState("")
    const [parkmapimageURL, setParkMapImageURL] = useState("")

    const [tc_contactperson, set_tc_contactperson] = useState("");

    const[loaded, setloaded] = useState(false)
    


    useEffect(()=>{
        if (param_v && param_v=='kt'){
                if (loaded){   
                    
            if (param_p && param_p=="true"){
                setTimeout(function() { 
                    
                    window.print(); }, 1000);
            
            }
            }
        }
    }, [loaded])


    
    useEffect(()=>{

        $('.stand_NAME').addClass('standName_card')
      document.body.classList.add('boverride')

      

        if (plan_id > 0){
            StandeditorService.getplan(tmp_id).then(response => {
              setContent(response)
            });
            
  
            StandeditorService.getplandata(tmp_id, param_lang==null?'pl' : param_lang).then(response => {
                setPlanWidth(response.width)
              setPlanHeight(response.height)
              setWallColor(response.color_wall)
              setStandColor(response.color_stand)

              if ((response.background_position) && (response.background_position!='')){
            
                setbackgroundPosition(response.background_position)
                $('#plan_CONTENT').css('backgroundPosition', response.background_position)
              }
              
  
              setPlanNAME(response.name)
              setPlanDate(new Date(response.date).toLocaleDateString()); //+ ' ' + new Date(response.date).toLocaleTimeString());
              setPlanGroupID(response.group_id)
              setPlanModifiedDate(response.modified)



          
               set_tc_listingdate(response.tc_listingdate)
              set_tc_checkingdate(response.tc_checkingdate)
          
              set_tc_constructiondate(response.tc_constructiondate)
              set_tc_componentgraphicsdate(response.tc_componentgraphicsdate ? response.tc_componentgraphicsdate : '')
          
              set_tc_readygraphicsdate(response.tc_readygraphicsdate ? response.tc_readygraphicsdate : '')
              set_tc_componentpresentationdate(response.tc_componentpresentationdate ? response.tc_componentpresentationdate : '')
          
              set_tc_readypresentationdate(response.tc_readypresentationdate)
              set_tc_othercommands(response.tc_othercommands)
          
              set_tc_disassemblystand(response.tc_disassemblystand ? response.tc_disassemblystand : '')
              set_tc_insertsdate(response.tc_insertsdate)
          
              set_tc_fairdate(response.tc_fairdate)
              set_tc_objectname(response.tc_objectname)
              set_tc_objectaddress(response.tc_objectaddress)
              set_tc_visitoropeninghours(response.tc_visitoropeninghours)
              set_tc_exhibitoropeninghours(response.tc_exhibitoropeninghours)
              set_tc_contactperson(response.tc_contactperson? response.tc_contactperson : '')
          
              
              setNote1(response.note1?response.note1 : '' )
              setNote2(response.note2?response.note2:'')
              set_tc_disassemblybuiltstand(response.tc_disassemblybuiltstand ? response.tc_disassemblybuiltstand : '')
              setParkrules(response.parkrules? response.parkrules : '')
              set_tc_othercomments(response.tc_othercomments? response.tc_othercomments : '')


              setParkMapImage(response.tc_parkmapimage)
              if (response.tc_parkmapimage != ''){
                planService.getImage(response.tc_parkmapimage).then( response => {

                  const encoder = new TextEncoder();
                  var byteArray = encoder.encode(response.data)
                  const charCodes =  response.data;
                  const byteNumbers = new Array(charCodes.length);
                  const url = "data:;base64," + response.data

                  setParkMapImageURL(url)
                 
                  StandeditorService.getplanbackground(tmp_id).then(response => {
                    const encoder = new TextEncoder();
                    var byteArray = encoder.encode(response)
                    const charCodes =  response;
                    const byteNumbers = new Array(charCodes.length);
                    var url = "" 
                    url ="data:image/png;base64," + response;
            
                    setBackgroundImg(url);
                    //console.log(url)
                    setloaded(true)
                           
                  });

                  

                }

                ).catch( error => {
                    console.log(error)
                    StandeditorService.getplanbackground(tmp_id).then(response => {
                        const encoder = new TextEncoder();
                        var byteArray = encoder.encode(response)
                        const charCodes =  response;
                        const byteNumbers = new Array(charCodes.length);
                        var url = "" 
                        url ="data:image/png;base64," + response;
                
                        setBackgroundImg(url);
                        //console.log(url)
                        setloaded(true)
                               
                      });
                  }
                )
              }else{

                StandeditorService.getplanbackground(tmp_id).then(response => {
                    const encoder = new TextEncoder();
                    var byteArray = encoder.encode(response)
                    const charCodes =  response;
                    const byteNumbers = new Array(charCodes.length);
                    var url = "" 
                    url ="data:image/png;base64," + response;
            
                    setBackgroundImg(url);
                    //console.log(url)
                    setloaded(true)
                           
                  });

                
              }
        
                

            });
              
        }
        $('.printit').click(function(){
            window.print();
        });
      
        if (param_v && param_v=='d'){
            //plan zabudowy
            if (param_p && param_p=='t'){
                $('.sbs-download').css({opacity: 1});
                $('body').removeClass('loading');
                document.title = 'Plan zabudowy ' + plan_NAME; 

                if (param_background && param_background=='t'){
                    setHideBackground(false)
                }

                $('#plan_CONTENT .stand_ADD_INFO').each(function(){
                    $(this).css('background-color', '#ffff00!important');
                    $(this).css('width', 'fit-content'); 
                    $(this).css('z-index', '9999');             
                    $(this).css('overflow', 'visible');
                    $(this).css('font-size', '12px');
                    $(this).css('color', '#000000!important');
                    $(this).css('position', 'relative'); 
                    $(this).css('margin-top', '-34px'); 
                    

                });


                $('#plan_CONTENT .is tr.stand td.stand p').each(function(){
                    $(this).css('opacity', 1);
                });

                $('#plan_CONTENT div.stand div.stand_TEXT span.stand_NR').each(function(){
                    $(this).css('font-size', '18px');
                    $(this).css('color', '#000000 !important');
                });

                $('#plan_CONTENT div.stand div.stand_TEXT span.standName_card').each(function(){
                    $(this).css('overflow', 'visible');
                    
                    
                    $(this).css('text-overflow', 'clip!important');
                    $(this).css('white-space', 'normal');
                    $(this).css('color', '#000000 !important');
                });

                $('#plan_CONTENT div.stand div.stand_TEXT p.stand_NAME').each(function(){
                    $(this).css('overflow', 'visible');
                    $(this).css('margin-bottom', '15px'); 
                    
                    $(this).css('text-overflow', 'clip!important');
                    $(this).css('white-space', 'normal');
                    $(this).css('color', '#000000 !important');
                });

                $('#plan_CONTENT div.stand div.stand_TEXT span.stand_NR_L').each(function(){
                    $(this).hide();
                });
                $('#plan_CONTENT div.stand div.stand_TEXT span.stand_NR_R').each(function(){
                    $(this).hide();
                });
            }

            if (param_l1 && param_l1=='t'){
                $('.sbs-download').css({opacity: 1});
                $('body').removeClass('loading');
                document.title = 'Lista wystawców ' + plan_NAME

                f_UpdateLegend();
                f_UpdateListDL1();
                /*$('#list-table').tablesort({
                    sortList: [ [0,0] ],
                    headers: { 
                        0: { sorter: 'text', string: 'max' },
                        4: { sorter: 'digit' } 
                    } 
                });*/            
            }

            if (param_l2 && param_l2=='t'){
                $('.sbs-download').css({opacity: 1});
                $('body').removeClass('loading');
                document.title = 'Lista wystawców z dodatkowymi informacjami ' + plan_NAME

                f_UpdateLegend();
                f_UpdateListDL2();
                /*$('#list-table').tablesort({
                    sortList: [ [0,0] ],
                    headers: { 
                        0: { sorter: 'text', string: 'max' },
                        8: { sorter: 'text' },
                    } 
                }); */       
            }

            if (param_l2e && param_l2e=='t'){
                $('.sbs-download').css({opacity: 1});
                $('body').removeClass('loading');
                document.title = 'Lista wystawców z dodatkowymi informacjami ' + plan_NAME

                f_UpdateLegend();
                f_UpdateListDL2();
            
            }

            if (param_gns && param_gns=='t'){
                $('.sbs-download').css({opacity: 1});
                $('body').removeClass('loading');
                document.title = 'Grafika na stoisko ' + plan_NAME

                f_UpdateLegend();
                f_UpdateListGNS();
                
                $('#list-table tbody tr').each(function(index, element) {
                    if ($(this).find('td:eq(2)').find('p').html() == '') {$(this).remove();}
                });
                
               /* $('#list-table').tablesort({
                    sortList: [ [0,0] ],
                    headers: { 
                        0: { sorter: 'text', string: 'max' },
                        2: { sorter: 'digit', string: 'max' } 
                    } 
                });  
                */         
	
            }
        }    
        if (param_v && param_v=='t'){
            if (param_p1 && param_p1 == 't'){

                //plan stoisk
                $('.sbs-download').css({opacity: 1});
                $('body').removeClass('loading');
				document.title = 'Plan stoisk ' + plan_NAME

                f_UpdateLegend();
                f_UpdateSur();

                /* if stand reserved bg red */
                $('#plan_CONTENT .is tr.stand').each(function(){
                    $(this).css('background-color', '#ec4343');
                });

                /* if stand free make bg grey */
                $('#plan_CONTENT .is .free tr.stand').each(function(){
                    $(this).css('background-color', '#f1f1f2');
                });

                $('#plan_CONTENT .is tr.stand td.stand p').each(function(){
                    $(this).hide();
                });

                $('#plan_CONTENT .stand_ADD_INFO').each(function(){
                    $(this).hide();
                });

                $('#plan_CONTENT div.stand div.stand_TEXT span.stand_NR').each(function(){
                    $(this).css('font-size', '18px');
                    $(this).css('color', '#000000 !important');
                });

                $('#plan_CONTENT div.stand div.stand_TEXT span.stand_NR_L').each(function(){
                    $(this).hide();
                });
                $('#plan_CONTENT div.stand div.stand_TEXT span.stand_NR_R').each(function(){
                    $(this).hide();
                });


                $('#plan_CONTENT div.stand div.stand_TEXT span.stand_NAME').each(function(){
                    $(this).css('font-size', '10px');
                    $(this).css('padding-left', '4px');
                });

                $('#plan_CONTENT .stand_TEXT').each(function(){
                    $(this).css('max-width', '150%');
                    $(this).css('text-overflow', 'unset');
                })

                $('#plan_CONTENT .stand_NAME').each(function(){
                    $(this).css('text-overflow', 'unset');
                    $(this).css('max-width', '150%');
                })

                

                
            }
            if (param_p2 && param_p2=="t"){
                
                $('.sbs-download').css({opacity: 1});
                $('body').removeClass('loading');
                document.title = 'Plan rezerwacji ' + plan_NAME
    
                /* if stand reserved bg red */
                $('#plan_CONTENT .is tr.stand').each(function(){
                    $(this).css('background-color', 'transparent');
                });
                $('#plan_CONTENT .is table.stand').each(function(){
                    $(this).css('background-color', 'transparent');
                });
    
                f_UpdateLegend();
                f_UpdateColors();

                $('#plan_CONTENT .is tr.stand td.stand p').each(function(){
                    $(this).hide();
                });

                $('#plan_CONTENT .stand_ADD_INFO').each(function(){
                    $(this).hide();
                });

                $('#plan_CONTENT div.stand div.stand_TEXT span.stand_NR').each(function(){
                    $(this).css('font-size', '18px');
                    $(this).css('color', '#000000 !important');
                });

                $('#plan_CONTENT div.stand div.stand_TEXT span.stand_NR_L').each(function(){
                    $(this).hide();
                });
                $('#plan_CONTENT div.stand div.stand_TEXT span.stand_NR_R').each(function(){
                    $(this).hide();
                });


                $('#plan_CONTENT div.stand div.stand_TEXT span.stand_NAME').each(function(){
                    $(this).css('font-size', '10px');
                    $(this).css('padding-left', '4px');
                });


                $('#plan_CONTENT div.stand div.stand_TEXT span.standName_card').each(function(){
                    $(this).css('overflow', 'visible');
                    
                    
                    $(this).css('text-overflow', 'clip!important');
                    $(this).css('white-space', 'normal');
                    $(this).css('color', '#000000 !important');
                });

                $('#plan_CONTENT div.stand div.stand_TEXT p.stand_NAME').each(function(){
                    $(this).css('overflow', 'visible');
                    $(this).css('margin-bottom', '15px'); 
                    
                    $(this).css('text-overflow', 'clip!important');
                    $(this).css('white-space', 'normal');
                    $(this).css('color', '#000000 !important');
                });



            }

            if (param_p3 && param_p3=="t"){
                $('.sbs-download').css({opacity: 1});
                $('body').removeClass('loading');
                document.title = 'Informacja techniczna ' + plan_NAME
    
                /* if stand reserved bg red */
                $('#plan_CONTENT .is tr.stand').each(function(){
                    $(this).css('background-color', 'transparent');
                });
                $('#plan_CONTENT .is table.stand').each(function(){
                    $(this).css('background-color', 'transparent');
                });
    
                f_UpdateLegend();
                f_UpdateTechnicalColors();

                $('#plan_CONTENT .is tr.stand td.stand p').each(function(){
                    $(this).hide();
                });

                $('#plan_CONTENT .stand_ADD_INFO').each(function(){
                    $(this).hide();
                });

                $('#plan_CONTENT div.stand div.stand_TEXT span.stand_NR').each(function(){
                    $(this).css('font-size', '18px');
                    $(this).css('color', '#000000 !important');
                });

                $('#plan_CONTENT div.stand div.stand_TEXT span.stand_NR_L').each(function(){
                    $(this).hide();
                });
                $('#plan_CONTENT div.stand div.stand_TEXT span.stand_NR_R').each(function(){
                    $(this).hide();
                });


                $('#plan_CONTENT div.stand div.stand_TEXT span.stand_NAME').each(function(){
                    $(this).css('font-size', '10px');
                    $(this).css('padding-left', '4px');
                });

                $('#plan_CONTENT div.stand div.stand_TEXT span.standName_card').each(function(){
                    $(this).css('overflow', 'visible');
                    
                    
                    $(this).css('text-overflow', 'clip!important');
                    $(this).css('white-space', 'normal');
                    $(this).css('color', '#000000 !important');
                });

                $('#plan_CONTENT div.stand div.stand_TEXT p.stand_NAME').each(function(){
                    $(this).css('overflow', 'visible');
                    $(this).css('margin-bottom', '15px'); 
                    
                    $(this).css('text-overflow', 'clip!important');
                    $(this).css('white-space', 'normal');
                    $(this).css('color', '#000000 !important');
                });


            }

            if (param_l1 && param_l1=="t"){
                $('.sbs-download').css({opacity: 1});
                $('body').removeClass('loading');
				document.title = 'Lista wystawców ' + plan_NAME

                f_UpdateLegend();
				f_UpdateListTL1();
                /*$('#list-table').tablesort({
                    sortList: [ [0,0] ],
                    headers: { 
                        0: { sorter: 'text', string: 'max' },
                        3: { sorter: 'digit', } 
                    } 
                });  */      
            }

            if (param_l2 && param_l2=="t"){
                $('.sbs-download').css({opacity: 1});
                $('body').removeClass('loading');
				document.title = 'Lista wystawców z danymi na fryz ' + plan_NAME

                f_UpdateLegend();
				f_UpdateListTL2();
               /* $('#list-table').tablesort({
                    sortList: [ [5,5] ],
                    headers: { 
                    } 
                });   
                */       
            }

            if (param_l3 && param_l3=="t"){
                $('.sbs-download').css({opacity: 1});
                $('body').removeClass('loading');
				document.title = 'Lista wystawców z danymi na fryz ' + plan_NAME

                f_UpdateLegend();
				f_UpdateListTL2();

               		
            }

            if (param_l4 && param_l4=="t"){
                $('.sbs-download').css({opacity: 1});
                $('body').removeClass('loading');
                document.title = plan_NAME + '-' +  plan_DATE

                f_UpdateLegend();
                f_UpdateListTL4();
    
            }

            if (param_l5 && param_l5=="t"){
                $('.sbs-download').css({opacity: 1});
                $('body').removeClass('loading');
                document.title = plan_NAME + '-' +  plan_DATE

                f_UpdateLegend();
                f_UpdateListTL5();

                   
            }
    

        }
        if (param_v && param_v=='kt'){
            $('.sbs-download').css({opacity: 1});
            $('body').removeClass('loading');
            document.title = 'Karta techniczna Wystawcy ' + plan_NAME

            f_UpdateLegend();
            f_UpdateKW(param_s);

          //  if (param_p && param_p=="true"){
          //      window.print();
          //  }

            
            var standID = $('.kw_2_nr').eq(0).text();
            var standName = $('.kw_1_nws').eq(0).text();
            var cookieName = plan_id.toString() + standID + 'deliver';
            var standEmail = $('.stand_DETAILS').eq(0).attr('stand_o_mail');
            var cookieExists = readCookie(cookieName);
            var isPrintOn = getQueryParam('p');
            var standUniqueID = getQueryParam('s');


            if ((!cookieExists) && (isPrintOn == false) ) {
                $('.deliver-accept').delay(1000).fadeIn("slow");
            }

            $(".deliver-accept button").click(function(e){

                e.preventDefault();

                $('.deliver-accept').fadeOut("slow");

                createCookie(cookieName, 'seen', 365);

                $.ajax({
                    type: 'POST',
                    crossDomain: true,
                    url: '/deliver-accept.php',
                    data : {
                        planID : plan_id,
                        standID : standID,
                        standName : standName,
                        standEmail : standEmail,
                        standUniqueID : standUniqueID

                    },
                    success: function(data) {
                    }
                });
            });
            
        }




        window.matchMedia("print").addListener(function(){
            f_UpdateKW(param_s);
        })
        
    })

    function getQueryParam(param: string) {
        var result =  window.location.search.match(
            new RegExp("(\\?|&)" + param + "(\\[\\])?=([^&]*)")
        );
        return result ? result[3] : false;
    }

    function createCookie(name: string,value: string,days: number) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime()+(days*24*60*60*1000));
            var expires = "; expires="+date.toDateString();  //toGMTString();
        }
        else var expires = "";
        document.cookie = name+"="+value+expires+"; path=/";
    }

    function readCookie(name: string) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    // Update Legend	
	function f_UpdateLegend(){
		// Stand
		if($('#plan_CONTENT div.stand').length > 0){$('#plan-legend p.legend-number').show(); $('#plan-legend p.legend-stand').show(); $('#plan-legend p.legend-stand-own').show();}
		else {$('#plan-legend p.legend-number').hide(); $('#plan-legend p.legend-stand').hide(); $('#plan-legend p.legend-stand-own').hide();}
		// Wall
		if($('#plan_CONTENT td.wall').length > 0){$('#plan-legend p.legend-wall').show();}
		else {$('#plan-legend p.legend-wall').hide();}
		// Filar
		if($('#plan_CONTENT td.filar').length > 0){$('#plan-legend p.legend-filar').show();}
		else {$('#plan-legend p.legend-filar').hide();}
		// Exit
		if($('#plan_CONTENT td.exit').length > 0){$('#plan-legend p.legend-exit').show();}
		else {$('#plan-legend p.legend-exit').hide();}
		// Stand Light
		if($('#plan_CONTENT p.light-t').length > 0 || $('#plan_CONTENT p.light-b').length > 0 || $('#plan_CONTENT p.light-l').length > 0 || $('#plan_CONTENT p.light-r').length > 0){$('#plan-legend p.legend-light').show();}
		else {$('#plan-legend p.legend-light').hide();}

		//Halogen
		if($('#plan_CONTENT p.halogen-t').length > 0 || $('#plan_CONTENT p.halogen-b').length > 0 || $('#plan_CONTENT p.halogen-l').length > 0 || $('#plan_CONTENT p.halogen-r').length > 0){$('#plan-legend p.legend-halogen').show();}
		else {$('#plan-legend p.legend-halogen').hide();}

		// Stand Volt
		if($('#plan_CONTENT p.volt-c').length > 0 || $('#plan_CONTENT p.volt-m').length > 0){$('#plan-legend p.legend-volt').show();}
		else {$('#plan-legend p.legend-volt').hide();}
		// Exit
		if($('#plan_CONTENT p.exit-t').length > 0 || $('#plan_CONTENT p.exit-b').length > 0 || $('#plan_CONTENT p.exit-l').length > 0 || $('#plan_CONTENT p.exit-r').length > 0){$('#plan-legend p.legend-exit').show();}
		else {$('#plan-legend p.legend-exit').hide();}
		// Lada
		if($('#plan_CONTENT p.any-t').length > 0 || $('#plan_CONTENT p.any-b').length > 0 || $('#plan_CONTENT p.any-l').length > 0 || $('#plan_CONTENT p.any-r').length > 0){$('#plan-legend p.legend-any').show();}
		else {$('#plan-legend p.legend-any').hide();}
		// Regal
		if($('#plan_CONTENT p.regal-t').length > 0 || $('#plan_CONTENT p.regal-b').length > 0 || $('#plan_CONTENT p.regal-l').length > 0 || $('#plan_CONTENT p.regal-r').length > 0){$('#plan-legend p.legend-regal').show();}
		else {$('#plan-legend p.legend-regal').hide();}
		// Hanger
		if($('#plan_CONTENT p.hanger-t').length > 0 || $('#plan_CONTENT p.hanger-b').length > 0 || $('#plan_CONTENT p.hanger-l').length > 0 || $('#plan_CONTENT p.hanger-r').length > 0){$('#plan-legend p.legend-hanger').show();}
		else {$('#plan-legend p.legend-hanger').hide();}
		// Hoker
		if($('#plan_CONTENT p.hooker-t').length > 0 || $('#plan_CONTENT p.hooker-b').length > 0 || $('#plan_CONTENT p.hooker-l').length > 0 || $('#plan_CONTENT p.hooker-r').length > 0){$('#plan-legend p.legend-hooker').show();}
		else {$('#plan-legend p.legend-hooker').hide();}
		// Leaflets
		if($('#plan_CONTENT p.leaflets-t').length > 0 || $('#plan_CONTENT p.leaflets-b').length > 0 || $('#plan_CONTENT p.leaflets-l').length > 0 || $('#plan_CONTENT p.leaflets-r').length > 0){$('#plan-legend p.legend-leaflets').show();}
		else {$('#plan-legend p.legend-leaflets').hide();}
	}
	function f_UpdateKW(id: string | null){
        
        var tempList_stand_NR = $('#'+id).find('span.stand_NR').html();
        var tempList_stand_SUR = $('#'+id).find('p.stand_SUR').html();
        var tempList_stand_ADD_INFO = $('#'+id).find('p.stand_ADD_INFO').html();
        var tempList_stand_ADD_CLIENT = $('#'+id).find('p.stand_ADD_CLIENT').html();
        var tempList_stand_FRYZ = $('#'+id).find('p.stand_FRYZ').html();
        var tempList_stand_NAME = $('#'+id).find('span.stand_NAME').html();
        if (tempList_stand_NAME == '') {tempList_stand_NAME = '-';}
        if (tempList_stand_FRYZ == '') {tempList_stand_FRYZ = '-';}
        
        var stand_FRYZ_SELECT = $('#'+id).find('p.stand_FRYZ_SELECT').html() != null ? $('#'+id).find('p.stand_FRYZ_SELECT').html() : ' ' ;
                
                if (stand_FRYZ_SELECT.trim() !=''){
                    stand_FRYZ_SELECT = stand_FRYZ_SELECT + ': ';
                }

        $('.kw_1_nr').html('Numer stoiska: '+tempList_stand_NR);
        $('.kw_2_nr').html('Numer stoiska: '+tempList_stand_NR);

        $('.kw_1_nws').html(tempList_stand_NAME);
        $('.kw_1_dnf').html(stand_FRYZ_SELECT + tempList_stand_FRYZ);


        $('#kw_info_1').html(tempList_stand_ADD_INFO);
        $('#kw_info_2').html(tempList_stand_ADD_CLIENT);
        if (tempList_stand_ADD_INFO == '') {$('#kw_info_1').parent().hide();}
        if (tempList_stand_ADD_CLIENT == '') {$('#kw_info_2').parent().hide();}
        
        if(tempList_stand_SUR == 'Zabudowana') {
            $('.kw_1').show();
            $('.kw_2').hide();
        } else {
            $('.kw_1').hide();
            $('.kw_2').show();
            $('.kw_d1.kw_graphics').hide();
            
            $('.kw_decr_if_hidden').each(function() {
                var new_value = parseInt($(this).html().replace(/^[\.]+|[\.]+$/g, "")) * 1;
                $(this).html((new_value-1) + '.');
            });
        }
        
        var tempStand = $('#'+id).parent().html();
        var tempStandHeight = $('#'+id).height();
        var tempStandWidth = $('#'+id).width();
        
        tempStandWidth = $('#'+id).find('tr').eq(0).children('td').length *20;
        tempStandHeight = $('#'+id).find('tr').length *20;

        //var transform = (document.getElementById(stand_ID) as HTMLElement).style.removeProperty('transform') ;
        console.log(document.getElementById(id as string)?.style.transform);
        var transform = document.getElementById(id as string)?.style.transform;

        if (transform){
            if (transform.includes('rotate(90deg)') || transform.includes('rotate(270deg)')){
                $('.download-stoisko').html(tempStand).height(tempStandWidth as number).width(tempStandHeight as number);
            }else{
                $('.download-stoisko').html(tempStand).height(tempStandHeight as number).width(tempStandWidth as number);
            }
        }else{
            $('.download-stoisko').html(tempStand).height(tempStandHeight as number).width(tempStandWidth as number);
        }
        
        var temp_gfx_1_checkbox = $('#'+id).find('div.stand_DETAILS').attr('gfx_1_checkbox');
        var temp_gfx_1_count = $('#'+id).find('div.stand_DETAILS').attr('gfx_1_count');
        var temp_gfx_1_status = $('#'+id).find('div.stand_DETAILS').attr('gfx_1_status');
        var temp_gfx_1_info = $('#'+id).find('div.stand_DETAILS').attr('gfx_1_info');
        
        var temp_gfx_2_checkbox = $('#'+id).find('div.stand_DETAILS').attr('gfx_2_checkbox');
        var temp_gfx_2_count = $('#'+id).find('div.stand_DETAILS').attr('gfx_2_count');
        var temp_gfx_2_status = $('#'+id).find('div.stand_DETAILS').attr('gfx_2_status');
        var temp_gfx_2_info = $('#'+id).find('div.stand_DETAILS').attr('gfx_2_info');

        var temp_gfx_3_checkbox = $('#'+id).find('div.stand_DETAILS').attr('gfx_3_checkbox');
        var temp_gfx_3_count = $('#'+id).find('div.stand_DETAILS').attr('gfx_3_count');
        var temp_gfx_3_status = $('#'+id).find('div.stand_DETAILS').attr('gfx_3_status');
        var temp_gfx_3_info = $('#'+id).find('div.stand_DETAILS').attr('gfx_3_info');
        
        var temp_gfx_4_checkbox = $('#'+id).find('div.stand_DETAILS').attr('gfx_4_checkbox');
        var temp_gfx_4_count = $('#'+id).find('div.stand_DETAILS').attr('gfx_4_count');
        var temp_gfx_4_status = $('#'+id).find('div.stand_DETAILS').attr('gfx_4_status');
        var temp_gfx_4_info = $('#'+id).find('div.stand_DETAILS').attr('gfx_4_info');
        
        var temp_gfx_5_checkbox = $('#'+id).find('div.stand_DETAILS').attr('gfx_5_checkbox');
        var temp_gfx_5_count = $('#'+id).find('div.stand_DETAILS').attr('gfx_5_count');
        var temp_gfx_5_status = $('#'+id).find('div.stand_DETAILS').attr('gfx_5_status');
        var temp_gfx_5_info = $('#'+id).find('div.stand_DETAILS').attr('gfx_5_info');
        
        var temp_gfx_6_checkbox = $('#'+id).find('div.stand_DETAILS').attr('gfx_6_checkbox');
        var temp_gfx_6_count = $('#'+id).find('div.stand_DETAILS').attr('gfx_6_count');
        var temp_gfx_6_status = $('#'+id).find('div.stand_DETAILS').attr('gfx_6_status');
        var temp_gfx_6_info = $('#'+id).find('div.stand_DETAILS').attr('gfx_6_info');
        
        var temp_gfx_7_checkbox = $('#'+id).find('div.stand_DETAILS').attr('gfx_7_checkbox');
        var temp_gfx_7_count = $('#'+id).find('div.stand_DETAILS').attr('gfx_7_count');
        var temp_gfx_7_status = $('#'+id).find('div.stand_DETAILS').attr('gfx_7_status');
        var temp_gfx_7_info = $('#'+id).find('div.stand_DETAILS').attr('gfx_7_info');
        
        var temp_gfx_8_checkbox = $('#'+id).find('div.stand_DETAILS').attr('gfx_8_checkbox');
        var temp_gfx_8_count = $('#'+id).find('div.stand_DETAILS').attr('gfx_8_count');
        var temp_gfx_8_status = $('#'+id).find('div.stand_DETAILS').attr('gfx_8_status');
        var temp_gfx_8_info = $('#'+id).find('div.stand_DETAILS').attr('gfx_8_info');
            
        if (temp_gfx_1_checkbox == 'true' || temp_gfx_2_checkbox == 'true' || temp_gfx_3_checkbox == 'true' || temp_gfx_4_checkbox == 'true' || temp_gfx_5_checkbox == 'true' || temp_gfx_6_checkbox == 'true' || temp_gfx_7_checkbox == 'true' || temp_gfx_8_checkbox == 'true') {
            {(param_lang) &&  (param_lang!='en') ? $('#kw_info_3').html('dotyczy WYSTAWCY') : $('#kw_info_3').html('applies to EXHIBITOR')};
            $('#kw_info_4').html('<br />');
        } else {
            {(param_lang) &&  (param_lang!='en') ?  $('#kw_info_3').html('nie dotyczy WYSTAWCY') : $('#kw_info_3').html('not applicable to the EXHIBITOR')};
            $('.gfx-not-linked').hide();
        }
        
        if (temp_gfx_1_checkbox == 'true') {$('#kw_info_4').html($('#kw_info_4').html()+'<p class="kw_text kw_textb" style="margin-left: 18px;"><strong>Projekt stoiska z wizualizacją</strong>, ilość: '+temp_gfx_1_count+', uwagi: '+temp_gfx_1_info+'</p>');}
        if (temp_gfx_2_checkbox == 'true') {$('#kw_info_4').html($('#kw_info_4').html()+'<p class="kw_text kw_textb" style="margin-left: 18px;"><strong>Projekt banneru</strong>, ilość: '+temp_gfx_2_count+', uwagi: '+temp_gfx_2_info+'</p>');}
        if (temp_gfx_3_checkbox == 'true') {$('#kw_info_4').html($('#kw_info_4').html()+'<p class="kw_text kw_textb" style="margin-left: 18px;"><strong>Oklejenie wkładów (ścian)</strong>, ilość: '+temp_gfx_3_count+', uwagi: '+temp_gfx_3_info+'</p>');}
        if (temp_gfx_4_checkbox == 'true') {$('#kw_info_4').html($('#kw_info_4').html()+'<p class="kw_text kw_textb" style="margin-left: 18px;"><strong>Oklejenie fryzów</strong>, ilość: '+temp_gfx_4_count+', uwagi: '+temp_gfx_4_info+'</p>');}
        if (temp_gfx_5_checkbox == 'true') {$('#kw_info_4').html($('#kw_info_4').html()+'<p class="kw_text kw_textb" style="margin-left: 18px;"><strong>Oklejenie lady - wkład podstawowy</strong>, ilość: '+temp_gfx_5_count+', uwagi: '+temp_gfx_5_info+'</p>');}
        if (temp_gfx_6_checkbox == 'true') {$('#kw_info_4').html($('#kw_info_4').html()+'<p class="kw_text kw_textb" style="margin-left: 18px;"><strong>Logo na fryzie (przed napisem)</strong>, ilość: '+temp_gfx_6_count+', uwagi: '+temp_gfx_6_info+'</p>');}
        if (temp_gfx_7_checkbox == 'true') {$('#kw_info_4').html($('#kw_info_4').html()+'<p class="kw_text kw_textb" style="margin-left: 18px;"><strong>Wydruk + montaż banneru</strong>, ilość: '+temp_gfx_7_count+', uwagi: '+temp_gfx_7_info+'</p>');}
        if (temp_gfx_8_checkbox == 'true') {$('#kw_info_4').html($('#kw_info_4').html()+'<p class="kw_text kw_textb" style="margin-left: 18px;"><strong>Montaż banneru / wkładów</strong>, ilość: '+temp_gfx_8_count+', uwagi: '+temp_gfx_8_info+'</p>');}
        
        var stand_O_MAIL_STATUS = $('#'+id).find('div.stand_DETAILS').attr('stand_O_MAIL_STATUS');
        if (stand_O_MAIL_STATUS == '1') {stand_O_MAIL_STATUS = 'do wysłania';}
        if (stand_O_MAIL_STATUS == '2') {stand_O_MAIL_STATUS = 'wysłano';}
        if (stand_O_MAIL_STATUS == '3') {stand_O_MAIL_STATUS = 'otrzymał';}
        if (stand_O_MAIL_STATUS == '4') {stand_O_MAIL_STATUS = 'potwierdzone telefonicznie';}
        if (stand_O_MAIL_STATUS == '5') {stand_O_MAIL_STATUS = 'potwierdzone mailowo';}
        $('#kwdsm').html(stand_O_MAIL_STATUS as string);
        
        $('#sbs-download-content').hide();
        $('#plan-legend').parent().hide();
        $('#planT').hide();
    }

	// Update Sur
	function f_UpdateSur(){
		if($('#plan_CONTENT div.stand').length > 0) {
			$('#plan_CONTENT div.stand').each(function() {
				var tempList_stand_SIZE = $(this).find('p.stand_SIZE').html();
				$(this).find('span.stand_NAME').html('('+tempList_stand_SIZE+'m&sup2;)');
			});
		}
	}
	

    

    function f_UpdateTechnicalColors(){
		var temp_DATA = new Date();
		var temp_DATA2 = temp_DATA.getFullYear().toString()+zeroWiodace((temp_DATA.getMonth()+1))+zeroWiodace(temp_DATA.getDate())+'';

       // if($('#plan_CONTENT div.ti_tosending').length > 0) {
	   //		$('#plan_CONTENT div.ti_tosending').each(function() {
	   //			$(this).attr('style', 'background-color: red !important;');
	    //		});
	  //	}
        if($('#plan_CONTENT div.stand').length > 0) {
			$('#plan_CONTENT div.stand').each(function() {
				//$(this).attr('style', 'background-color: red !important;');
                $(this).css({'background-color': ''});
                var attr_tmp = $(this).attr('style');
                $(this).attr('style', 'background-color: red !important;' + attr_tmp);
			});
		}

        if($('#plan_CONTENT div.ti_sent').length > 0) {
			$('#plan_CONTENT div.ti_sent').each(function() {
				//$(this).attr('style', 'background-color: yellow !important;');
                $(this).css({'background-color': ''});
                var attr_tmp = $(this).attr('style');
                $(this).attr('style', 'background-color: yellow !important;' + attr_tmp);
			});
		}

        if($('#plan_CONTENT div.ti_received').length > 0) {
			$('#plan_CONTENT div.ti_received').each(function() {
				//$(this).attr('style', 'background-color: #0a5c0a !important;');
                $(this).css({'background-color': ''});
                var attr_tmp = $(this).attr('style');
                $(this).attr('style', 'background-color: #0a5c0a !important;' + attr_tmp);
			});
		}

        if($('#plan_CONTENT div.ti_phoneconfirm').length > 0) {
			$('#plan_CONTENT div.ti_phoneconfirm').each(function() {
                $(this).css({'background-color': ''});
                var attr_tmp = $(this).attr('style');
				//$(this).attr('style', 'background-color: #00CC00 !important;');
                $(this).attr('style', 'background-color: #00CC00 !important;' + attr_tmp);
			});
		}

        if($('#plan_CONTENT div.ti_mailconfirm').length > 0) {
			$('#plan_CONTENT div.ti_mailconfirm').each(function() {
                $(this).css({'background-color': ''});
                var attr_tmp = $(this).attr('style');
				//$(this).attr('style', 'background-color: lime !important;');
                $(this).attr('style', 'background-color: lime !important;' + attr_tmp);
                 
			});
		}
		
		
	}

	function f_UpdateColors(){
		var temp_DATA = new Date();
		var temp_DATA2 = temp_DATA.getFullYear().toString()+zeroWiodace((temp_DATA.getMonth()+1))+zeroWiodace(temp_DATA.getDate())+'';

        if($('#plan_CONTENT div.stand').length > 0) {
			$('#plan_CONTENT div.stand').each(function() {
				//$(this).attr('style', 'background-color: #ffffff !important;');
                //$(this).css({'background-color': '#ffffff !important;'});
                $(this).css({'background-color': ''});
                var attr_tmp = $(this).attr('style');
                $(this).attr('style', 'background-color: #ffffff !important;' + attr_tmp);
			});
		}

		if($('#plan_CONTENT div.sold').length > 0) {
			$('#plan_CONTENT div.sold').each(function() {
				//$(this).attr('style', 'background-color: #ff2323 !important;');
                //$(this).css({'background-color': '#ff2323 !important;'});
                $(this).css({'background-color': ''});
                var attr_tmp = $(this).attr('style');
                $(this).attr('style', 'background-color: #ff2323 !important;'  + attr_tmp);
			});
		}

        if($('#plan_CONTENT div.book').length > 0) {
			$('#plan_CONTENT div.book').each(function() {
				//$(this).attr('style', 'background-color: yellow !important;');
                //$(this).css({'background-color': 'yellow !important;'});
                $(this).css({'background-color': ''});
                var attr_tmp = $(this).attr('style');
                $(this).attr('style', 'background-color: yellow !important;' + attr_tmp);
			});
		}

        if($('#plan_CONTENT div.nbindbook').length > 0) {
			$('#plan_CONTENT div.nbindbook').each(function() {
				//$(this).attr('style', 'background-color: yellow !important;');
                //$(this).attr('style', 'background: repeating-linear-gradient( 45deg, orange, yellow 10px, yellow 10px, yellow 20px);');

                //$(this).css({'background-color': 'yellow !important;'});
                //$(this).css({'background': 'repeating-linear-gradient( 45deg, orange, yellow 10px, yellow 10px, yellow 20px);'});
                $(this).css({'background-color': ''});
                var attr_tmp = $(this).attr('style');
                $(this).attr('style', 'background-color: yellow !important;' + 'background: repeating-linear-gradient( 45deg, orange, yellow 10px, yellow 10px, yellow 20px);' + attr_tmp);


                
			});
		}

        if($('#plan_CONTENT div.mparticipat').length > 0) {
			$('#plan_CONTENT div.mparticipat').each(function() {
				//$(this).attr('style', 'background-color: #FF00FF !important;');
                //$(this).attr('style', 'background: repeating-linear-gradient( 45deg, orange, #FF00FF 10px, #FF00FF 10px, #FF00FF 20px);');
                 
                //$(this).css({'background-color': 'FF00FF !important;'});
               // $(this).css({'background': 'repeating-linear-gradient( 45deg, orange, #FF00FF 10px, #FF00FF 10px, #FF00FF 20px);'});
               $(this).css({'background-color': ''});
               $(this).css({'background-color': ''});
                var attr_tmp = $(this).attr('style');
                $(this).attr('style', 'background-color: #FF00FF !important;' + 'background: repeating-linear-gradient( 45deg, orange, #FF00FF 10px, #FF00FF 10px, #FF00FF 20px);' +  attr_tmp);
			});
		}

        if($('#plan_CONTENT div.deal').length > 0) {
			$('#plan_CONTENT div.deal').each(function() {
				//$(this).attr('style', 'background-color: orange !important;');
                 
                //$(this).attr('style', 'background-color: orange !important;');
                $(this).css({'background-color': ''});
                var attr_tmp = $(this).attr('style');
                $(this).attr('style', 'background-color: orange !important;' + attr_tmp);

			});
		}

        if($('#plan_CONTENT div.risk').length > 0) {
			$('#plan_CONTENT div.risk').each(function() {
				//$(this).attr('style', 'background-color: magenta !important;');

               // $(this).css({'background-color': 'magenta !important;'});
               $(this).css({'background-color': ''});
               var attr_tmp = $(this).attr('style');
               $(this).attr('style', 'background-color: magenta !important;' + attr_tmp); 
			});
		}
		
		if($('#plan_CONTENT div.book').length > 0) {
			$('#plan_CONTENT div.book').each(function() {
				if($(this).attr('status_data')) {
				   //if(zamienGodziny(temp_DATA2) > (zamienGodziny((parseInt($(this).attr('status_data') as string)+(30*24) as number).toString()))) {$(this).attr('style', 'background-color: orange !important;');}
                   if(new Date(temp_DATA2) > (new Date((parseInt($(this).attr('status_data') as string)+(30*24) as number).toString()))) {$(this).attr('style', 'background-color: orange !important;');}
				
                }
			});
		}
	}
	function zeroWiodace(i: string | number) {
		return (i as number < 10)? '0'+i : i;
	}
	
        // Update List D L1
    function f_UpdateListDL1(){
        var tempList = '<tr class="empty"><td>&nbsp;</td><td>&nbsp;</td><td><p class="info">Lista wystawców jest pusta!</p></td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>';
            
        $('#list-table tbody').html(tempList)
        
        if($('#plan_CONTENT div.stand').length == 0) {
            $('#list-table tr.header').hide();
            $('#list-table tr.empty').show();
        } else {
            $('#list-table tr.header').show();
            $('#list-table tr.empty').hide();
                
                $('#plan_CONTENT div.stand').each(function() {
                var tempList_stand_ID = $(this).attr('id');
                var tempList_stand_NR = $(this).find('span.stand_NR').html();
                var tempList_stand_NAME = $(this).find('span.stand_NAME').html();
                var tempList_stand_SIZE = $(this).find('p.stand_SIZE').html();
                tempList_stand_SIZE = tempList_stand_SIZE.replace(".", ",");

                var tempList_stand_ADD_INFO = $(this).find('p.stand_ADD_INFO').html();
                var tempList_stand_FRYZ = $(this).find('p.stand_FRYZ').html();
                var tempList_stand_SUR = $(this).find('p.stand_SUR').html();
                            
                var tempList_stand_STATUS = '-';
                if ($(this).is('.free')) {tempList_stand_STATUS = 'Wolne';}
                if ($(this).is('.book')) {tempList_stand_STATUS = 'Zarezerwowane';}
                if ($(this).is('.nbindbook')) {tempList_stand_STATUS = 'Zarezerwowane (N)';}
                if ($(this).is('.mparticipat')) {tempList_stand_STATUS = 'Przeniesiony udział';}
                if ($(this).is('.deal')) {tempList_stand_STATUS = 'Wystawiona umowa';}
                if ($(this).is('.sold')) {tempList_stand_STATUS = 'Sprzedane';}
                if ($(this).is('.risk')) {tempList_stand_STATUS = 'Może podważyć umowę';}
                            
                $('#list-table tbody').append('<tr stand_ID="'+tempList_stand_ID+'"><td class="nr">'+tempList_stand_NR+'</td><td>'+tempList_stand_NAME+'</td><td>'+tempList_stand_FRYZ+'</td><td>'+tempList_stand_SUR+'</td><td class="a-right size">'+tempList_stand_SIZE+'</td></tr>');	
            });
            
            $("#list-table").trigger("update"); 
        }
    }

    // Update List D L2
    function f_UpdateListDL2(){
        var tempList = '<tr class="empty"><td>&nbsp;</td><td>&nbsp;</td><td><p class="info">Lista wystawców jest pusta!</p></td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>';
            
        $('#list-table tbody').html(tempList)
        
        if($('#plan_CONTENT div.stand').length == 0) {
            $('#list-table tr.header').hide();
            $('#list-table tr.empty').show();
        } else {
            $('#list-table tr.header').show();
            $('#list-table tr.empty').hide();
                
                $('#plan_CONTENT div.stand').each(function() {
                var tempList_stand_ID = $(this).attr('id');
                var tempList_stand_NR = $(this).find('span.stand_NR').html();
                var tempList_stand_NAME = $(this).find('span.stand_NAME').html();
                var tempList_stand_SIZE = $(this).find('p.stand_SIZE').html();
                tempList_stand_SIZE = tempList_stand_SIZE.replace(".", ",");

                var tempList_stand_ADD_INFO = $(this).find('p.stand_ADD_INFO').html();
                var tempList_stand_ADD_CLIENT = $(this).find('p.stand_ADD_CLIENT').html();
                var tempList_stand_FRYZ = $(this).find('p.stand_FRYZ').html();
                var tempList_stand_SUR = $(this).find('p.stand_SUR').html();
                            
                var tempList_stand_STATUS = '-';
                if ($(this).is('.free')) {tempList_stand_STATUS = 'Wolne';}
                if ($(this).is('.book')) {tempList_stand_STATUS = 'Zarezerwowane';}
                if ($(this).is('.nbindbook')) {tempList_stand_STATUS = 'Zarezerwowane (N)';}
                if ($(this).is('.mparticipat')) {tempList_stand_STATUS = 'Przeniesiony udział';}
                if ($(this).is('.deal')) {tempList_stand_STATUS = 'Wystawiona umowa';}
                if ($(this).is('.sold')) {tempList_stand_STATUS = 'Sprzedane';}
                if ($(this).is('.risk')) {tempList_stand_STATUS = 'Może podważyć umowę';}

                var stand_O_MAIL_STATUS = $(this).find('div.stand_DETAILS').attr('stand_O_MAIL_STATUS');
                if (!stand_O_MAIL_STATUS) {stand_O_MAIL_STATUS = ' ';}
                if (stand_O_MAIL_STATUS == '1') {stand_O_MAIL_STATUS = 'do wysłania';}
                if (stand_O_MAIL_STATUS == '2') {stand_O_MAIL_STATUS = 'wysłano';}
                if (stand_O_MAIL_STATUS == '3') {stand_O_MAIL_STATUS = 'otrzymał';}
                if (stand_O_MAIL_STATUS == '4') {stand_O_MAIL_STATUS = 'potwierdzone telefonicznie';}
                if (stand_O_MAIL_STATUS == '5') {stand_O_MAIL_STATUS = 'potwierdzone mailowo';}
                
                var stand_o_name = $(this).find('div.stand_DETAILS').attr('stand_o_name') != null ? $(this).find('div.stand_DETAILS').attr('stand_o_name') : '';	
                var stand_o_mail = $(this).find('div.stand_DETAILS').attr('stand_o_mail') != null ? $(this).find('div.stand_DETAILS').attr('stand_o_mail') : '' ;
                var stand_o_tel = $(this).find('div.stand_DETAILS').attr('stand_o_tel') != null ? $(this).find('div.stand_DETAILS').attr('stand_o_tel') : '' ;
                
                var stand_FRYZ_SELECT = $(this).find('p.stand_FRYZ_SELECT').html() != null ? $(this).find('p.stand_FRYZ_SELECT').html() : ' ' ;
                
                if (stand_FRYZ_SELECT.trim() !=''){
                    stand_FRYZ_SELECT = stand_FRYZ_SELECT + ': ';
                }
                                                    
                $('#list-table tbody').append('<tr stand_ID="'+tempList_stand_ID+'"><td class="nr">'+tempList_stand_NR+'</td><td>'+tempList_stand_NAME+'</td><td>'+tempList_stand_ADD_INFO+'</td><td>'+tempList_stand_ADD_CLIENT+'</td><td>'+ stand_FRYZ_SELECT +' ' + tempList_stand_FRYZ +'</td><td>'+stand_O_MAIL_STATUS+'</td><td>'+tempList_stand_SUR+'</td><td>'+tempList_stand_STATUS+'</td><td class="a-right size">'+tempList_stand_SIZE+'</td><td>'+stand_o_name+'</td><td>'+stand_o_mail+'</td><td>'+stand_o_tel+'</td></tr>');	
            });
            
            $("#list-table").trigger("update"); 
        }
    }

    // Update List T L1
    function f_UpdateListTL1(){
        var tempList = '<tr class="empty"><td>&nbsp;</td><td>&nbsp;</td><td><p class="info">Lista wystawców jest pusta!</p></td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>';
            
        $('#list-table tbody').html(tempList)
        
        if($('#plan_CONTENT div.stand').length == 0) {
            $('#list-table tr.header').hide();
            $('#list-table tr.empty').show();
        } else {
            $('#list-table tr.header').show();
            $('#list-table tr.empty').hide();
                
                $('#plan_CONTENT div.stand').each(function() {
                var tempList_stand_ID = $(this).attr('id');
                var tempList_stand_NR = $(this).find('span.stand_NR').html();
                var tempList_stand_NAME = $(this).find('span.stand_NAME').html();
                var tempList_stand_SIZE = $(this).find('p.stand_SIZE').html();
                tempList_stand_SIZE = tempList_stand_SIZE.replace(".", ",");

                var tempList_stand_ADD_INFO = $(this).find('p.stand_ADD_INFO').html();
                var tempList_stand_FRYZ = $(this).find('p.stand_FRYZ').html();
                var tempList_stand_SUR = $(this).find('p.stand_SUR').html();
                            
                var tempList_stand_STATUS = '-';
                if ($(this).is('.free')) {tempList_stand_STATUS = 'Wolne';}
                if ($(this).is('.book')) {tempList_stand_STATUS = 'Zarezerwowane';}		
                if ($(this).is('.nbindbook')) {tempList_stand_STATUS = 'Zarezerwowane (N)';}		
                if ($(this).is('.mparticipat')) {tempList_stand_STATUS = 'Przeniesiony udział';}
                if ($(this).is('.deal')) {tempList_stand_STATUS = 'Wystawiona umowa';}
                if ($(this).is('.sold')) {tempList_stand_STATUS = 'Sprzedane';}
                if ($(this).is('.risk')) {tempList_stand_STATUS = 'Może podważyć umowę';}
                            
                $('#list-table tbody').append('<tr stand_ID="'+tempList_stand_ID+'"><td class="nr">'+tempList_stand_NR+'</td><td>'+tempList_stand_NAME+'</td><td>'+tempList_stand_SUR+'</td><td class="a-right size">'+tempList_stand_SIZE+'</td></tr>');	
            });
            
            $("#list-table").trigger("update"); 
        }
    }

    // Update List T L2
    function f_UpdateListTL2(){
       var tempList = '<tr class="empty"><td>&nbsp;</td><td>&nbsp;</td><td><p class="info">Lista wystawców jest pusta!</p></td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>';
            
        $('#list-table tbody').html(tempList)
        
        if($('#plan_CONTENT div.stand').length == 0) {
            $('#list-table tr.header').hide();
            $('#list-table tr.empty').show();
        } else {
            $('#list-table tr.header').show();
            $('#list-table tr.empty').hide();
                
                $('#plan_CONTENT div.stand').each(function() {
                var tempList_stand_ID = $(this).attr('id');
                var tempList_stand_NR = $(this).find('span.stand_NR').html();
                var tempList_stand_NAME = $(this).find('span.stand_NAME').html();
                var tempList_stand_SIZE = $(this).find('p.stand_SIZE').html();
                tempList_stand_SIZE = tempList_stand_SIZE.replace(".", ",");

                var tempList_stand_ADD_INFO = $(this).find('p.stand_ADD_INFO').html();
                var tempList_stand_FRYZ = $(this).find('p.stand_FRYZ').html();
                var tempList_stand_SUR = $(this).find('p.stand_SUR').html();
                            
                var tempList_stand_STATUS = '-';
                if ($(this).is('.free')) {tempList_stand_STATUS = 'Wolne';}
                if ($(this).is('.book')) {tempList_stand_STATUS = 'Zarezerwowane';}
                if ($(this).is('.nbindbook')) {tempList_stand_STATUS = 'Zarezerwowanem (N)';}
                if ($(this).is('.mparticipat')) {tempList_stand_STATUS = 'Przeniesiony udział';}
                if ($(this).is('.deal')) {tempList_stand_STATUS = 'Wystawiona umowa';}
                if ($(this).is('.sold')) {tempList_stand_STATUS = 'Sprzedane';}
                if ($(this).is('.risk')) {tempList_stand_STATUS = 'Może podważyć umowę';}

                $('#list-table tbody').append('<tr stand_ID="'+tempList_stand_ID+'"><td class="nr">'+tempList_stand_NR+'</td><td>'+tempList_stand_NAME+'</td><td>'+tempList_stand_FRYZ+'</td><td>'+tempList_stand_SUR+'</td><td class="a-right size">'+tempList_stand_SIZE+'</td></tr>');	
            });
            
            $("#list-table").trigger("update"); 
        }
    }

    // Update List T L4
    function f_UpdateListTL4(){
        var tempList = '<tr class="empty"><td>&nbsp;</td><td>&nbsp;</td><td><p class="info">Lista wystawców jest pusta!</p></td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>';
            
        $('#list-table tbody').html(tempList)
        
        if($('#plan_CONTENT div.stand').length == 0) {
            $('#list-table tr.header').hide();
            $('#list-table tr.empty').show();
        } else {
            $('#list-table tr.header').show();
            $('#list-table tr.empty').hide();
                
                $('#plan_CONTENT div.stand').each(function() {
                var tempList_stand_ID = $(this).attr('id');
                var tempList_stand_NR = $(this).find('span.stand_NR').html();
                var tempList_stand_NAME = $(this).find('span.stand_NAME').html();
                var tempList_stand_SIZE = $(this).find('p.stand_SIZE').html();
                tempList_stand_SIZE = tempList_stand_SIZE.replace(".", ",");

                var tempList_stand_ADD_INFO = $(this).find('p.stand_ADD_INFO').html();
                var tempList_stand_FRYZ = $(this).find('p.stand_FRYZ').html();
                var tempList_stand_SUR = $(this).find('p.stand_SUR').html();
                            
                var stand_O_MAIL_STATUS = $(this).find('div.stand_DETAILS').attr('stand_O_MAIL_STATUS');

                if (!stand_O_MAIL_STATUS) {stand_O_MAIL_STATUS = ' ';}
                if (stand_O_MAIL_STATUS == '1') {stand_O_MAIL_STATUS = 'do wysłania';}
                if (stand_O_MAIL_STATUS == '2') {stand_O_MAIL_STATUS = 'wysłano';}
                if (stand_O_MAIL_STATUS == '3') {stand_O_MAIL_STATUS = 'otrzymał';}
                if (stand_O_MAIL_STATUS == '4') {stand_O_MAIL_STATUS = 'potwierdzone telefonicznie';}
                if (stand_O_MAIL_STATUS == '5') {stand_O_MAIL_STATUS = 'potwierdzone mailowo';}

                $('#list-table tbody').append('<tr stand_ID="'+tempList_stand_ID+'"><td class="nr">'+tempList_stand_NR+'</td><td>'+tempList_stand_NAME+'</td><td>'+stand_O_MAIL_STATUS+'</td></tr>');	
            });
            
            $("#list-table").trigger("update"); 
        }
    }

    // Update List T L5
    function f_UpdateListTL5(){
        var tempList = '<tr class="empty"><td>&nbsp;</td><td>&nbsp;</td><td><p class="info">Lista wystawców jest pusta!</p></td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>';
            
        $('#list-table tbody').html(tempList)
        
        if($('#plan_CONTENT div.stand').length == 0) {
            $('#list-table tr.header').hide();
            $('#list-table tr.empty').show();
        } else {
            $('#list-table tr.header').show();
            $('#list-table tr.empty').hide();
                
                $('#plan_CONTENT div.stand').each(function() {
                var tempList_stand_ID = $(this).attr('id');
                var tempList_stand_NR = $(this).find('span.stand_NR').html();
                var tempList_stand_NAME = $(this).find('span.stand_NAME').html();

                var tempList_stand_SIZE = $(this).find('p.stand_SIZE').html();
                tempList_stand_SIZE = tempList_stand_SIZE.replace(".", ",");

                var tempList_stand_ADD_INFO = $(this).find('p.stand_ADD_INFO').html();
                var tempList_stand_FRYZ = $(this).find('p.stand_FRYZ').html();
                var tempList_stand_SUR = $(this).find('p.stand_SUR').html();
                            
                var tempList_stand_STATUS = '-';
                if ($(this).is('.free')) {tempList_stand_STATUS = 'Wolne';}
                if ($(this).is('.book')) {tempList_stand_STATUS = 'Zarezerwowane';}
                if ($(this).is('.nbindbook')) {tempList_stand_STATUS = 'Zarezerwowane (N)';}
                if ($(this).is('.mparticipat')) {tempList_stand_STATUS = 'Przeniesiony udział';}
                if ($(this).is('.deal')) {tempList_stand_STATUS = 'Wystawiona umowa';}
                if ($(this).is('.sold')) {tempList_stand_STATUS = 'Sprzedane';}
                if ($(this).is('.risk')) {tempList_stand_STATUS = 'Może podważyć umowę';}

                $('#list-table tbody').append('<tr stand_ID="'+tempList_stand_ID+'"><td class="nr">'+tempList_stand_NR+'</td><td>'+tempList_stand_NAME+'</td><td>'+tempList_stand_ADD_INFO+'</td><td>'+tempList_stand_FRYZ+'</td><td>'+tempList_stand_SUR+'</td><td class="a-right size">'+tempList_stand_SIZE+'</td></tr>');	
            });
            
            $("#list-table").trigger("update"); 
        }
    }


    // Update List GNS
    function f_UpdateListGNS(){
        var tempList = '<tr class="empty"><td>&nbsp;</td><td>&nbsp;</td><td><p class="info">Lista wystawców jest pusta!</p></td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>';
            
        $('#list-table tbody').html(tempList)
        
        if($('#plan_CONTENT div.stand').length == 0) {
            $('#list-table tr.header').hide();
            $('#list-table tr.empty').show();
        } else {
            $('#list-table tr.header').show();
            $('#list-table tr.empty').hide();
                
                $('#plan_CONTENT div.stand').each(function() {
                    var tempList_stand_ID = $(this).attr('id');
                    var tempList_stand_NR = $(this).find('span.stand_NR').html();
                    var tempList_stand_NAME = $(this).find('span.stand_NAME').html();
                    var tempList_stand_SIZE = $(this).find('p.stand_SIZE').html();
                    tempList_stand_SIZE = tempList_stand_SIZE.replace(".", ",");
        
                    var tempList_stand_ADD_INFO = $(this).find('p.stand_ADD_INFO').html();
                    var tempList_stand_ADD_CLIENT = $(this).find('p.stand_ADD_CLIENT').html();
                    var tempList_stand_FRYZ = $(this).find('p.stand_FRYZ').html();
                    var tempList_stand_SUR = $(this).find('p.stand_SUR').html();
                                
                    var tempList_stand_STATUS = '-';
                    if ($(this).is('.free')) {tempList_stand_STATUS = 'Wolne';}
                    if ($(this).is('.book')) {tempList_stand_STATUS = 'Zarezerwowane';}
                    if ($(this).is('.nbindbook')) {tempList_stand_STATUS = 'Zarezerwowane (N)';}
                    if ($(this).is('.mparticipat')) {tempList_stand_STATUS = 'Przeniesiony udział';}
                    if ($(this).is('.deal')) {tempList_stand_STATUS = 'Wystawiona umowa';}
                    if ($(this).is('.sold')) {tempList_stand_STATUS = 'Sprzedane';}
                    if ($(this).is('.risk')) {tempList_stand_STATUS = 'Może podważyć umowę';}
                    
                    var tempList_stand_GNS_1 = '';
                    var tempList_stand_GNS_2 = '';
                    var tempList_stand_GNS_3 = '';
                    var tempList_stand_GNS_4 = '';
                    if ($(this).find('div.stand_DETAILS').attr('gfx_1_checkbox') == 'true'){
                        tempList_stand_GNS_1 = tempList_stand_GNS_1+'<strong>Projekt stoiska z wizualizacją</strong><br />';
                        tempList_stand_GNS_2 = tempList_stand_GNS_2+''+$(this).find('div.stand_DETAILS').attr('gfx_1_count')+'<br />';
                        tempList_stand_GNS_3 = tempList_stand_GNS_3+''+$(this).find('div.stand_DETAILS').attr('gfx_1_status')+'<br />';
                        tempList_stand_GNS_4 = tempList_stand_GNS_4+''+$(this).find('div.stand_DETAILS').attr('gfx_1_info')+'<br />';
                    }
                    if ($(this).find('div.stand_DETAILS').attr('gfx_2_checkbox') == 'true'){
                        tempList_stand_GNS_1 = tempList_stand_GNS_1+'<strong>Projekt banneru</strong><br />';
                        tempList_stand_GNS_2 = tempList_stand_GNS_2+''+$(this).find('div.stand_DETAILS').attr('gfx_2_count')+'<br />';
                        tempList_stand_GNS_3 = tempList_stand_GNS_3+''+$(this).find('div.stand_DETAILS').attr('gfx_2_status')+'<br />';
                        tempList_stand_GNS_4 = tempList_stand_GNS_4+''+$(this).find('div.stand_DETAILS').attr('gfx_2_info')+'<br />';
                    }
                    if ($(this).find('div.stand_DETAILS').attr('gfx_3_checkbox') == 'true'){
                        tempList_stand_GNS_1 = tempList_stand_GNS_1+'<strong>Oklejenie wkładów (ścian)</strong><br />';
                        tempList_stand_GNS_2 = tempList_stand_GNS_2+''+$(this).find('div.stand_DETAILS').attr('gfx_3_count')+'<br />';
                        tempList_stand_GNS_3 = tempList_stand_GNS_3+''+$(this).find('div.stand_DETAILS').attr('gfx_3_status')+'<br />';
                        tempList_stand_GNS_4 = tempList_stand_GNS_4+''+$(this).find('div.stand_DETAILS').attr('gfx_3_info')+'<br />';
                    }
                    if ($(this).find('div.stand_DETAILS').attr('gfx_4_checkbox') == 'true'){
                        tempList_stand_GNS_1 = tempList_stand_GNS_1+'<strong>Oklejenie fryzów</strong><br />';
                        tempList_stand_GNS_2 = tempList_stand_GNS_2+''+$(this).find('div.stand_DETAILS').attr('gfx_4_count')+'<br />';
                        tempList_stand_GNS_3 = tempList_stand_GNS_3+''+$(this).find('div.stand_DETAILS').attr('gfx_4_status')+'<br />';
                        tempList_stand_GNS_4 = tempList_stand_GNS_4+''+$(this).find('div.stand_DETAILS').attr('gfx_4_info')+'<br />';
                    }
                    if ($(this).find('div.stand_DETAILS').attr('gfx_5_checkbox') == 'true'){
                        tempList_stand_GNS_1 = tempList_stand_GNS_1+'<strong>Oklejenie lady - wkład podstawowy</strong><br />';
                        tempList_stand_GNS_2 = tempList_stand_GNS_2+''+$(this).find('div.stand_DETAILS').attr('gfx_5_count')+'<br />';
                        tempList_stand_GNS_3 = tempList_stand_GNS_3+''+$(this).find('div.stand_DETAILS').attr('gfx_5_status')+'<br />';
                        tempList_stand_GNS_4 = tempList_stand_GNS_4+''+$(this).find('div.stand_DETAILS').attr('gfx_5_info')+'<br />';
                    }
                    if ($(this).find('div.stand_DETAILS').attr('gfx_6_checkbox') == 'true'){
                        tempList_stand_GNS_1 = tempList_stand_GNS_1+'<strong>Logo na fryzie (przed napisem)</strong><br />';
                        tempList_stand_GNS_2 = tempList_stand_GNS_2+''+$(this).find('div.stand_DETAILS').attr('gfx_6_count')+'<br />';
                        tempList_stand_GNS_3 = tempList_stand_GNS_3+''+$(this).find('div.stand_DETAILS').attr('gfx_6_status')+'<br />';
                        tempList_stand_GNS_4 = tempList_stand_GNS_4+''+$(this).find('div.stand_DETAILS').attr('gfx_6_info')+'<br />';
                    }
                    if ($(this).find('div.stand_DETAILS').attr('gfx_7_checkbox') == 'true'){
                        tempList_stand_GNS_1 = tempList_stand_GNS_1+'<strong>Wydruk + montaż banneru</strong><br />';
                        tempList_stand_GNS_2 = tempList_stand_GNS_2+''+$(this).find('div.stand_DETAILS').attr('gfx_7_count')+'<br />';
                        tempList_stand_GNS_3 = tempList_stand_GNS_3+''+$(this).find('div.stand_DETAILS').attr('gfx_7_status')+'<br />';
                        tempList_stand_GNS_4 = tempList_stand_GNS_4+''+$(this).find('div.stand_DETAILS').attr('gfx_7_info')+'<br />';
                    }
                    if ($(this).find('div.stand_DETAILS').attr('gfx_8_checkbox') == 'true'){
                        tempList_stand_GNS_1 = tempList_stand_GNS_1+'<strong>Montaż banneru / wkładów</strong><br />';
                        tempList_stand_GNS_2 = tempList_stand_GNS_2+''+$(this).find('div.stand_DETAILS').attr('gfx_8_count')+'<br />';
                        tempList_stand_GNS_3 = tempList_stand_GNS_3+''+$(this).find('div.stand_DETAILS').attr('gfx_8_status')+'<br />';
                        tempList_stand_GNS_4 = tempList_stand_GNS_4+''+$(this).find('div.stand_DETAILS').attr('gfx_8_info')+'<br />';
                    }

                    $('#list-table tbody').append('<tr stand_ID="'+tempList_stand_ID+'"><td class="nr">'+tempList_stand_NR+'</td><td>'+tempList_stand_NAME+'</td><td><p style="font-size: 10px; line-height: 18px;">'+tempList_stand_GNS_1+'</p></td><td><p style="font-size: 10px; line-height: 18px;">'+tempList_stand_GNS_2+'</p></td><td><p style="font-size: 10px; line-height: 18px;">'+tempList_stand_GNS_3+'</p></td><td><p style="font-size: 10px; line-height: 18px;">'+tempList_stand_GNS_4+'</p></td></tr>');	
            });
            
            $("#list-table").trigger("update"); 
        }
    }


    var numberVertical=''
    var numberHorizontal=''
  
    for(let nVertical=1;nVertical<100;nVertical++) {
      numberVertical = numberVertical + '<p><span>' + nVertical + '</span></p>'
    }
    for(let nHorizontal=1;nHorizontal<100;nHorizontal++) {
      numberHorizontal = numberHorizontal + '<p><span>' + nHorizontal + '</span></p>'
    }


    function sortTable(e: any, index: number) {
        var table, rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
        table = document.getElementById("list-table");
        switching = true;
        // Set the sorting direction to ascending:
        dir = "asc";
        /* Make a loop that will continue until
        no switching has been done: */
        while (switching) {
          // Start by saying: no switching is done:
          switching = false;
          rows = (table as HTMLTableElement).rows;
          /* Loop through all table rows (except the
          first, which contains table headers): */
          for (i = 1; i < (rows.length - 1); i++) {
            // Start by saying there should be no switching:
            shouldSwitch = false;
            /* Get the two elements you want to compare,
            one from current row and one from the next: */
            x = rows[i].getElementsByTagName("TD")[index];
            y = rows[i + 1].getElementsByTagName("TD")[index];
            /* Check if the two rows should switch place,
            based on the direction, asc or desc: */
            if (dir == "asc") {
             //if (x.innerHTML.trimStart().toLowerCase() > y.innerHTML.trimStart().toLowerCase()) {
             if (x.innerHTML.trimStart().toLowerCase().localeCompare(y.innerHTML.trimStart().toLowerCase())>0) {
                // If so, mark as a switch and break the loop:
                shouldSwitch = true;
                break;
              }
            } else if (dir == "desc") {
              //if (x.innerHTML.trimStart().toLowerCase() < y.innerHTML.trimStart().toLowerCase()) {
              if (x.innerHTML.trimStart().toLowerCase().localeCompare(y.innerHTML.trimStart().toLowerCase())<0) {
                // If so, mark as a switch and break the loop:
                shouldSwitch = true;
                break;
              }
            }
          }
          if (shouldSwitch) {
            /* If a switch has been marked, make the switch
            and mark that a switch has been done: */
            rows[i].parentNode?.insertBefore(rows[i + 1], rows[i]);
            switching = true;
            // Each time a switch is done, increase this count by 1:
            switchcount ++;
          } else {
            /* If no switching has been done AND the direction is "asc",
            set the direction to "desc" and run the while loop again. */
            if (switchcount == 0 && dir == "asc") {
              dir = "desc";
              switching = true;
            }
          }
        }
    }

    function getexcel_l2et(): void {
        ($("#list-table") as any).table2excel({
            exclude: ".empty",
            name: plan_NAME + '-' + plan_DATE.replaceAll('.', '_'),
            filename: "Zaciąganie wszystkich ustaleń z Klientami_" + plan_NAME
        });	
    }

    function getexcel_gnst(): void {
        ($("#list-table") as any).table2excel({
            exclude: ".empty",
            name: plan_NAME + '-' + plan_DATE.replaceAll('.', '_'),
            filename: "Grafika na stoisko " + plan_NAME
        });	
    }

    function getexcel_l3t(): void {
        ($("#list-table") as any).table2excel({
            exclude: ".empty",
            name: plan_NAME + '-' + plan_DATE.replaceAll('.', '_'),
            filename: "Lista wystawców z danymi na fryz" + plan_NAME
        });	
    }

    function getexcel_l4t(): void {
        ($("#list-table") as any).table2excel({
            exclude: ".empty",
            name: plan_NAME + '-' + plan_DATE.replaceAll('.', '_'),
            filename:  plan_NAME + '-' + plan_DATE.replaceAll('.', '_')
        });	
    }

    function getexcel_l5t(): void {
        ($("#list-table") as any).table2excel({
            exclude: ".empty",
            name: plan_NAME + '-' + plan_DATE.replaceAll('.', '_'),
            filename:  plan_NAME + '-' + plan_DATE.replaceAll('.', '_')
        });	
    }


    return (
       
        <section className="content"> 

        { (param_v) &&  (param_v=='d') ? 
        
              ////////// Wersja Szczegółowa :: Pokaż Plan
               (param_p) &&  (param_p=='t') ? 
                    <table className="sbs-download">
                    <tbody>
                        <tr>
                            <td id="sbs-download-title"><p className="title">{plan_NAME} &nbsp;&nbsp; Data: {plan_DATE}</p></td>
                        </tr>
                        <tr>
                            <td id="sbs-download-content">
                                <div className="sbs-download-div-center">
                                        
                                    <table cellSpacing="0" className="plan-preview-table">
                                    <tbody>    
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-top"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tr">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-left"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                            <td className="plan-preview-table-center">
                                                <table cellSpacing="0" id="plan_CONTENT" style={{width: plan_width *40,  backgroundImage: hideBackground ? 'none' : `url(${backgroundImg})`, backgroundPosition:"left 0px top 0px" ,  height: plan_height * 40}}>{parse(plan_CONTENT)}</table>
                                            </td>
                                            <td className="plan-preview-table-right"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-bl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-bottom"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-br">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>	
                                    </tbody>    
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div id="plan-legend">
                                    <p className="plan-legend-title">Legenda</p>
                                    <p className="legend-number">[<span className="number">04</span>] Numer stoiska</p>
                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: color_stand}}>&nbsp;</span> Wykładzina</p>
                                    <p className="legend-stand-own"><span className="stand-own" style={{backgroundColor: "#f1f1f2"}}>&nbsp;</span> Zabudowa własna</p>
                                    <p className="legend-wall"><span className="wall" style={{backgroundColor: color_wall}}>&nbsp;</span> Sciana</p>
                                    <p className="legend-filar"><span className="filar" style={{backgroundColor: color_wall}}>&nbsp;</span> Filar</p>
                                    <p className="legend-exitplan"><img src="/dist/_img/plan-legend-exitplan.png" alt="" /> Wejście</p>
                                    <br />
                                    <p className="legend-light"><img src="/dist/_img/plan-legend-light.png" alt="" /> Punkt świetlny</p>
                                    <p className="legend-volt"><img src="/dist/_img/plan-legend-volt.png" alt="" /> Gniazdo elektryczne</p>
                                    <p className="legend-any"><img src="/dist/_img/plan-legend-lada.png" alt="" /> lada</p>
                                    <p className="legend-regal"><img src="/dist/_img/plan-legend-regal.png" alt="" /> Regał</p>
                                    <p className="legend-hanger"><img src="/dist/_img/plan-legend-hanger.png" alt="" /> Wieszak</p>
                                    <p className="legend-hoker"><img src="/dist/_img/plan-legend-hoker.png" alt="" /> Hoker</p>
                                    <p className="legend-leaflets"><img src="/dist/_img/plan-legend-leaflets.png" alt="" /> Ulotki</p>
                                    <p className="legend-exit"><img src="/dist/_img/plan-legend-exit.png" alt="" /> Drzwi</p>        
                                </div>    
                            </td>
                        </tr>
                    </tbody>    
                    </table>
                    
                : 
                
                ////////// Wersja Szczegółowa :: Pokaż Listę wystawców
                (param_l1) &&  (param_l1=='t') ? 
                    <table className="sbs-download">
                     <tbody>   
                        <tr>
                            <td id="sbs-download-title"><p className="title">{plan_NAME}  &nbsp;&nbsp; Data: {plan_DATE}</p></td>
                        </tr>
                        <tr className="none">
                            <td id="sbs-download-content">
                                <div className="sbs-download-div-center">
                                        
                                    <table cellSpacing="0" className="plan-preview-table">
                                    <tbody>    
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-top"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tr">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-left"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                            <td className="plan-preview-table-center">
                                                <table cellSpacing="0" id="plan_CONTENT" style={{width: plan_width*40,height: plan_height*40}}>{parse(plan_CONTENT)}</table>
                                            </td>
                                            <td className="plan-preview-table-right"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-bl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-bottom"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-br">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>	
                                    </tbody>    
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr className="none">
                            <td>
                                <div id="plan-legend">
                                    <p className="plan-legend-title">Legenda</p>
                                    <p className="legend-number">[<span className="number">04</span>] Numer stoiska</p>
                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: color_stand}}>&nbsp;</span> Wykładzina</p>
                                    <p className="legend-stand-own"><span className="stand-own" style={{backgroundColor: "#f1f1f2"}}>&nbsp;</span> Zabudowa własna</p>
                                    <p className="legend-wall"><span className="wall" style={{backgroundColor: color_wall}}>&nbsp;</span> Sciana</p>
                                    <p className="legend-filar"><span className="filar" style={{backgroundColor: color_wall}}>&nbsp;</span> Filar</p>
                                    <p className="legend-exitplan"><img src="/dist/_img/plan-legend-exitplan.png" alt="" /> Wejście</p>
                                    <br />
                                    <p className="legend-light"><img src="/dist/_img/plan-legend-light.png" alt="" /> Punkt świetlny</p>
                                    <p className="legend-volt"><img src="/dist/_img/plan-legend-volt.png" alt="" /> Gniazdo elektryczne</p>
                                    <p className="legend-any"><img src="/dist/_img/plan-legend-lada.png" alt="" /> lada</p>
                                    <p className="legend-regal"><img src="/dist/_img/plan-legend-regal.png" alt="" /> Regał</p>
                                    <p className="legend-hanger"><img src="/dist/_img/plan-legend-hanger.png" alt="" /> Wieszak</p>
                                    <p className="legend-hoker"><img src="/dist/_img/plan-legend-hoker.png" alt="" /> Hoker</p>
                                    <p className="legend-leaflets"><img src="/dist/_img/plan-legend-leaflets.png" alt="" /> Ulotki</p>
                                    <p className="legend-exit"><img src="/dist/_img/plan-legend-exit.png" alt="" /> Drzwi</p>        
                                </div>    
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div id="download-list">
                                    <table className="table-tab" id="list-table">
                                        <thead>
                                            <tr className="header">
                                                <th onClick={(e) => sortTable(e, 0)} className="sort nr"><strong>Nr:</strong></th>
                                                <th onClick={(e) => sortTable(e, 1)} className="sort"><strong>Nazwa:</strong></th>
                                                <th onClick={(e) => sortTable(e, 2)} className="sort"><strong>Dane na fryz:</strong></th>
                                                <th onClick={(e) => sortTable(e, 3)} className="sort"><strong>Powierzchnia:</strong></th>
                                                <th onClick={(e) => sortTable(e, 4)} className="sort size"><strong>m&sup2;</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="empty"><td>&nbsp;</td><td><p className="info">Lista wystawców jest pusta!</p></td><td>&nbsp;</td><td>&nbsp;</td></tr>
                                        </tbody>
                                    </table>                
                                </div>    
                            </td>
                        </tr>  
                    </tbody>                  
                    </table>
                : 

                // Wersja Szczegółowa :: Pokaż Listę wystawców z dodatkowymi informacjami z dodatkowymi ustaleniami z Klientem
                (param_l2) &&  (param_l2=='t') ? 
                    <table className="sbs-download">
                    <tbody>    
                        <tr>
                            <td id="sbs-download-title"><p className="title">{plan_NAME} &nbsp;&nbsp; Data: {plan_DATE}</p></td>
                        </tr>
                        <tr className="none">
                            <td id="sbs-download-content">
                                <div className="sbs-download-div-center">
                                        
                                    <table cellSpacing="0" className="plan-preview-table">
                                    <tbody>    
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-top"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tr">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-left"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                            <td className="plan-preview-table-center">
                                                <table cellSpacing="0" id="plan_CONTENT" style={{width: plan_width*40, height: plan_height*40}}>{parse(plan_CONTENT)}</table>
                                            </td>
                                            <td className="plan-preview-table-right"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-bl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-bottom"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-br">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>	
                                    </tbody>    
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr className="none">
                            <td>
                                <div id="plan-legend">
                                    <p className="plan-legend-title">Legenda</p>
                                    <p className="legend-number">[<span className="number">04</span>] Numer stoiska</p>
                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: color_stand}}>&nbsp;</span> Wykładzina</p>
                                    <p className="legend-stand-own"><span className="stand-own" style={{backgroundColor: "#f1f1f2"}}>&nbsp;</span> Zabudowa własna</p>
                                    <p className="legend-wall"><span className="wall" style={{backgroundColor: color_wall}}>&nbsp;</span> Sciana</p>
                                    <p className="legend-filar"><span className="filar" style={{backgroundColor: color_wall}}>&nbsp;</span> Filar</p>
                                    <p className="legend-exitplan"><img src="/dist/_img/plan-legend-exitplan.png" alt="" /> Wejście</p>
                                    <br />
                                    <p className="legend-light"><img src="/dist/_img/plan-legend-light.png" alt="" /> Punkt świetlny</p>
                                    <p className="legend-volt"><img src="/dist/_img/plan-legend-volt.png" alt="" /> Gniazdo elektryczne</p>
                                    <p className="legend-any"><img src="/dist/_img/plan-legend-lada.png" alt="" /> lada</p>
                                    <p className="legend-regal"><img src="/dist/_img/plan-legend-regal.png" alt="" /> Regał</p>
                                    <p className="legend-hanger"><img src="/dist/_img/plan-legend-hanger.png" alt="" /> Wieszak</p>
                                    <p className="legend-hoker"><img src="/dist/_img/plan-legend-hoker.png" alt="" /> Hoker</p>
                                    <p className="legend-leaflets"><img src="/dist/_img/plan-legend-leaflets.png" alt="" /> Ulotki</p>
                                    <p className="legend-exit"><img src="/dist/_img/plan-legend-exit.png" alt="" /> Drzwi</p>        
                                </div>    
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div id="download-list">
                                    <table className="table-tab" id="list-table">
                                        <thead>
                                            <tr className="header">
                                                <th onClick={(e) => sortTable(e, 0)} className="sort nr"><strong>Nr:</strong></th>
                                                <th onClick={(e) => sortTable(e, 1)} className="sort"><strong>Nazwa:</strong></th>
                                                <th onClick={(e) => sortTable(e, 2)} className="sort"><strong>Dodatkowe zamówienia (zabudowa):</strong></th>
                                                <th onClick={(e) => sortTable(e, 3)} className="sort"><strong>Dodatkowe zamówienia (organizator):</strong></th>
                                                <th onClick={(e) => sortTable(e, 4)} className="sort"><strong>Dane na fryz:</strong></th>
                                                <th onClick={(e) => sortTable(e, 5)} className="sort"><strong>Info tech:</strong></th>
                                                <th onClick={(e) => sortTable(e, 6)} className="sort"><strong>Powierzchnia:</strong></th>
                                                <th onClick={(e) => sortTable(e, 7)} className="sort"><strong>Status:</strong></th>
                                                <th onClick={(e) => sortTable(e, 8)} className="sort size"><strong>m&sup2;</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="empty"><td>&nbsp;</td><td><p className="info">Lista wystawców jest pusta!</p></td><td>&nbsp;</td><td>&nbsp;</td></tr>
                                        </tbody>
                                    </table>                
                                </div>    
                            </td>
                        </tr>  
                    </tbody>                  
                    </table>
                : 
                // Wersja Szczegółowa :: Excel Listy wystawców z dodatkowymi informacjami z dodatkowymi ustaleniami z Klientem
                (param_l2e) &&  (param_l2e=='t') ? 
                    <table className="sbs-download;table2excel">
                    <tbody>    
                        <tr>
                            <td id="sbs-download-title"><p className="title">{plan_NAME} &nbsp;&nbsp; Data: {plan_DATE}</p></td>
                        </tr>
                        <tr>
                            <td id="sbs-download-excel"><p onClick={getexcel_l2et} >Pobierz plik <strong>Excel</strong></p></td>
                        </tr>                
                        <tr className="none">
                            <td id="sbs-download-content">
                                <div className="sbs-download-div-center">
                                        
                                    <table cellSpacing="0" className="plan-preview-table">
                                    <tbody>    
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-top"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tr">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-left"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                            <td className="plan-preview-table-center">
                                                <table cellSpacing="0" id="plan_CONTENT" style={{width: plan_width*40, height: plan_height*40}}>{parse(plan_CONTENT)}</table>
                                            </td>
                                            <td className="plan-preview-table-right"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-bl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-bottom"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-br">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>
                                    </tbody>    	
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr className="none">
                            <td>
                                <div id="plan-legend">
                                    <p className="plan-legend-title">Legenda</p>
                                    <p className="legend-number">[<span className="number">04</span>] Numer stoiska</p>
                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: color_stand}}>&nbsp;</span> Wykładzina</p>
                                    <p className="legend-stand-own"><span className="stand-own" style={{backgroundColor: "#f1f1f2"}}>&nbsp;</span> Zabudowa własna</p>
                                    <p className="legend-wall"><span className="wall" style={{backgroundColor: color_wall}}>&nbsp;</span> Sciana</p>
                                    <p className="legend-filar"><span className="filar" style={{backgroundColor: color_wall}}>&nbsp;</span> Filar</p>
                                    <p className="legend-exitplan"><img src="/dist/_img/plan-legend-exitplan.png" alt="" /> Wejście</p>
                                    <br />
                                    <p className="legend-light"><img src="/dist/_img/plan-legend-light.png" alt="" /> Punkt świetlny</p>
                                    <p className="legend-volt"><img src="/dist/_img/plan-legend-volt.png" alt="" /> Gniazdo elektryczne</p>
                                    <p className="legend-any"><img src="/dist/_img/plan-legend-lada.png" alt="" /> lada</p>
                                    <p className="legend-regal"><img src="/dist/_img/plan-legend-regal.png" alt="" /> Regał</p>
                                    <p className="legend-hanger"><img src="/dist/_img/plan-legend-hanger.png" alt="" /> Wieszak</p>
                                    <p className="legend-hoker"><img src="/dist/_img/plan-legend-hoker.png" alt="" /> Hoker</p>
                                    <p className="legend-leaflets"><img src="/dist/_img/plan-legend-leaflets.png" alt="" /> Ulotki</p>
                                    <p className="legend-exit"><img src="/dist/_img/plan-legend-exit.png" alt="" /> Drzwi</p>        
                                </div>    
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div id="download-list">
                                    <table className="table-tab" id="list-table">
                                        <thead>
                                            <tr className="header">
                                                <th onClick={(e) => sortTable(e, 0)} className="sort nr"><strong>Nr:</strong></th>
                                                <th onClick={(e) => sortTable(e, 1)} className="sort"><strong>Nazwa:</strong></th>
                                                <th onClick={(e) => sortTable(e, 2)} className="sort"><strong>Dodatkowe zamówienia (zabudowa):</strong></th>
                                                <th onClick={(e) => sortTable(e, 3)} className="sort"><strong>Dodatkowe zamówienia (organizator):</strong></th>
                                                <th onClick={(e) => sortTable(e, 4)} className="sort"><strong>Dane na fryz:</strong></th>
                                                <th onClick={(e) => sortTable(e, 5)} className="sort"><strong>Info tech:</strong></th>
                                                <th onClick={(e) => sortTable(e, 6)}className="sort"><strong>Powierzchnia:</strong></th>
                                                <th onClick={(e) => sortTable(e, 7)} className="sort"><strong>Status:</strong></th>
                                                <th onClick={(e) => sortTable(e, 8)} className="sort size"><strong>m&sup2;</strong></th>
                                                <th onClick={(e) => sortTable(e, 9)} className="sort"><strong>Imię i nazwisko:</strong></th>
                                                <th onClick={(e) => sortTable(e, 10)} className="sort"><strong>Adres e-mail:</strong></th>
                                                <th onClick={(e) => sortTable(e, 11)} className="sort"><strong>Nr telefonu:</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="empty">
                                                <td>&nbsp;</td>
                                                <td><p className="info">Lista wystawców jest pusta!</p></td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                                <td>&nbsp;</td>
                                            </tr>
                                        </tbody>
                                    </table>                
                                </div>    
                            </td>
                        </tr>
                    </tbody>                    
                    </table>
                : 

                // Wersja Szczegółowa :: Grafika na stoisko
                (param_gns) &&  (param_gns=='t') ? 
                    <table className="sbs-download;table2excel">
                    <tbody>    
                        <tr>
                            <td id="sbs-download-title"><p className="title">{plan_NAME} &nbsp;&nbsp; Data: {plan_DATE}</p></td>
                        </tr>
                        <tr>
                            <td id="sbs-download-excel"><p onClick={getexcel_gnst} >Pobierz plik <strong>Excel</strong></p></td>
                        </tr>                
                        <tr className="none">
                            <td id="sbs-download-content">
                                <div className="sbs-download-div-center">
                                        
                                    <table cellSpacing="0" className="plan-preview-table">
                                    <tbody>    
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-top"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tr">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-left"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                            <td className="plan-preview-table-center">
                                                <table cellSpacing="0" id="plan_CONTENT" style={{width: plan_width*40, height: plan_height*40}}>{parse(plan_CONTENT)}</table>
                                            </td>
                                            <td className="plan-preview-table-right"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-bl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-bottom"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-br">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>	
                                    </tbody>    
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr className="none">
                            <td>
                                <div id="plan-legend">
                                    <p className="plan-legend-title">Legenda</p>
                                    <p className="legend-number">[<span className="number">04</span>] Numer stoiska</p>
                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: color_stand}}>&nbsp;</span> Wykładzina</p>
                                    <p className="legend-stand-own"><span className="stand-own" style={{backgroundColor: "#f1f1f2"}}>&nbsp;</span> Zabudowa własna</p>
                                    <p className="legend-wall"><span className="wall" style={{backgroundColor: color_wall}}>&nbsp;</span> Sciana</p>
                                    <p className="legend-filar"><span className="filar" style={{backgroundColor: color_wall}}>&nbsp;</span> Filar</p>
                                    <p className="legend-exitplan"><img src="/dist/_img/plan-legend-exitplan.png" alt="" /> Wejście</p>
                                    <br />
                                    <p className="legend-light"><img src="/dist/_img/plan-legend-light.png" alt="" /> Punkt świetlny</p>
                                    <p className="legend-volt"><img src="/dist/_img/plan-legend-volt.png" alt="" /> Gniazdo elektryczne</p>
                                    <p className="legend-any"><img src="/dist/_img/plan-legend-lada.png" alt="" /> lada</p>
                                    <p className="legend-regal"><img src="/dist/_img/plan-legend-regal.png" alt="" /> Regał</p>
                                    <p className="legend-hanger"><img src="/dist/_img/plan-legend-hanger.png" alt="" /> Wieszak</p>
                                    <p className="legend-hoker"><img src="/dist/_img/plan-legend-hoker.png" alt="" /> Hoker</p>
                                    <p className="legend-leaflets"><img src="/dist/_img/plan-legend-leaflets.png" alt="" /> Ulotki</p>
                                    <p className="legend-exit"><img src="/dist/_img/plan-legend-exit.png" alt="" /> Drzwi</p>        
                                </div>    
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div id="download-list">
                                    <table className="table-tab" id="list-table">
                                        <thead>
                                            <tr className="header">
                                                <th onClick={(e) => sortTable(e, 0)} className="sort nr"><strong>Nr:</strong></th>
                                                <th onClick={(e) => sortTable(e, 1)}className="sort"><strong>Nazwa:</strong></th>
                                                <th onClick={(e) => sortTable(e, 2)} className="sort"><strong>Produkt:</strong></th>
                                                <th onClick={(e) => sortTable(e, 3)} className="sort"><strong>Ilość:</strong></th>
                                                <th onClick={(e) => sortTable(e, 4)} className="sort"><strong>Status:</strong></th>
                                                <th onClick={(e) => sortTable(e, 5)} className="sort"><strong>Uwagi:</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="empty"><td>&nbsp;</td><td><p className="info">Lista wystawców jest pusta!</p></td><td>&nbsp;</td><td>&nbsp;</td></tr>
                                        </tbody>
                                    </table>                
                                </div>    
                            </td>
                        </tr>  
                    </tbody>                  
                    </table>
                : <></> 
              
            : <></> 
        }

        { (param_v) &&  (param_v=='t') ? 
                // Wersja Handlowa :: Pokaż Plan 2 kolorowy (wolne i pozostałe)
               
                (param_p1) && (param_p1 == 't') ? 
               
                    <table className="sbs-download">
                    
                    <tbody>    
                        <tr>
                            <td id="sbs-download-title"><p className="title">{plan_NAME} &nbsp;&nbsp; Data: {plan_DATE}</p></td>
                        </tr>
                        <tr>
                            <td id="sbs-download-content">
                                <div className="sbs-download-div-center">
                                        
                                    <table cellSpacing="0" className="plan-preview-table">
                                    <tbody>    
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-top"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tr">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-left"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                            <td className="plan-preview-table-center">
                                                <table cellSpacing="0" id="plan_CONTENT" style={{width: plan_width*40, height: plan_height*40}} className="trade">{parse(plan_CONTENT)}</table>
                                            </td>
                                            <td className="plan-preview-table-right"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-bl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-bottom"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-br">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>	
                                    </tbody>    
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div id="plan-legend">
                                    <p className="plan-legend-title">Legenda</p>
                                    <p className="legend-number">[<span className="number">04</span>] Numer stoiska</p>
                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: color_stand}}>&nbsp;</span> Wykładzina</p>
                                    <p className="legend-stand-own"><span className="stand-own" style={{backgroundColor: "#f1f1f2"}}>&nbsp;</span> Zabudowa własna</p>
                                    <p className="legend-wall"><span className="wall" style={{backgroundColor: color_wall}}>&nbsp;</span> Sciana</p>
                                    <p className="legend-filar"><span className="filar" style={{backgroundColor: color_wall}}>&nbsp;</span> Filar</p>
                                    <p className="legend-exitplan"><img src="/dist/_img/plan-legend-exitplan.png" alt="" /> Wejście</p>
                                    <br />
                                    <p className="legend-light"><img src="/dist/_img/plan-legend-light.png" alt="" /> Punkt świetlny</p>
                                    <p className="legend-volt"><img src="/dist/_img/plan-legend-volt.png" alt="" /> Gniazdo elektryczne</p>
                                    <p className="legend-any"><img src="/dist/_img/plan-legend-lada.png" alt="" /> lada</p>
                                    <p className="legend-regal"><img src="/dist/_img/plan-legend-regal.png" alt="" /> Regał</p>
                                    <p className="legend-hanger"><img src="/dist/_img/plan-legend-hanger.png" alt="" /> Wieszak</p>
                                    <p className="legend-hoker"><img src="/dist/_img/plan-legend-hoker.png" alt="" /> Hoker</p>
                                    <p className="legend-leaflets"><img src="/dist/_img/plan-legend-leaflets.png" alt="" /> Ulotki</p>
                                    <p className="legend-exit"><img src="/dist/_img/plan-legend-exit.png" alt="" /> Drzwi</p>        
                                </div>    
                            </td>
                        </tr>
                    </tbody>    
                    </table>
                
                : 
                // Wersja Handlowa :: Pokaż Plan trójkolorowych (sprzedane, rezerwacja i wolne)
                (param_p2) && (param_p2 == 't') ?
                    <table className="sbs-download">
                    <tbody>    
                        <tr>
                            <td id="sbs-download-title"><p className="title">{plan_NAME} &nbsp;&nbsp; Data: {plan_DATE}</p></td>
                        </tr>
                        <tr>
                            <td id="sbs-download-content">
                                <div className="sbs-download-div-center">
                                        
                                    <table cellSpacing="0" className="plan-preview-table">
                                    <tbody>    
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-top"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tr">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-left"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                            <td className="plan-preview-table-center">
                                                <table cellSpacing="0" id="plan_CONTENT" style={{width: plan_width*40, height: plan_height*40}} className="trade">{parse(plan_CONTENT)}</table>
                                            </td>
                                            <td className="plan-preview-table-right"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-bl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-bottom"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-br">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>	
                                    </tbody>    
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div id="plan-legend">
                                    <p className="plan-legend-title">Legenda</p>
                                    <p className="legend-number">[<span className="number">04</span>] Numer stoiska</p>

                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: "#ff2323"}}>&nbsp;</span> Sprzedane stoisko</p>

                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: "orange"}}>&nbsp;</span> Wystawiona umowa</p>

                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: "yellow"}}>&nbsp;</span> Zarezerwowane stoisko</p>

                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: "#afafaf"}}>&nbsp;</span> Wolne stoisko</p>

                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: "magenta"}}>&nbsp;</span> Może podwayć umowe</p>

                                    <p className="legend-filar"><span className="filar" style={{backgroundColor: color_wall}}>&nbsp;</span> Filar</p>
                                    <p className="legend-exitplan"><img src="/dist/_img/plan-legend-exitplan.png" alt="" /> Wejście</p>
                                    <br />
                                    <p className="legend-light"><img src="/dist/_img/plan-legend-light.png" alt="" /> Punkt świetlny</p>
                                    <p className="legend-volt"><img src="/dist/_img/plan-legend-volt.png" alt="" /> Gniazdo elektryczne</p>
                                    <p className="legend-any"><img src="/dist/_img/plan-legend-lada.png" alt="" /> lada</p>
                                    <p className="legend-regal"><img src="/dist/_img/plan-legend-regal.png" alt="" /> Regał</p>
                                    <p className="legend-hanger"><img src="/dist/_img/plan-legend-hanger.png" alt="" /> Wieszak</p>
                                    <p className="legend-hoker"><img src="/dist/_img/plan-legend-hoker.png" alt="" /> Hoker</p>
                                    <p className="legend-leaflets"><img src="/dist/_img/plan-legend-leaflets.png" alt="" /> Ulotki</p>
                                    <p className="legend-exit"><img src="/dist/_img/plan-legend-exit.png" alt="" /> Drzwi</p>        
                                </div>    
                            </td>
                        </tr>
                    </tbody>    
                    </table>
                : 
                // Wersja tecniczna :: Pokaż Plan od statusu karty technicznej (potwietrdzone mailowo)
                (param_p3) && (param_p3 == 't') ?
                    <table className="sbs-download">
                    <tbody>    
                        <tr>
                            <td id="sbs-download-title"><p className="title">{plan_NAME} &nbsp;&nbsp; Data: {plan_DATE}</p></td>
                        </tr>
                        <tr>
                            <td id="sbs-download-content">
                                <div className="sbs-download-div-center">
                                        
                                    <table cellSpacing="0" className="plan-preview-table">
                                    <tbody>    
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-top"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tr">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-left"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                            <td className="plan-preview-table-center">
                                                <table cellSpacing="0" id="plan_CONTENT" style={{width: plan_width*40, height: plan_height*40}} className="trade">{parse(plan_CONTENT)}</table>
                                            </td>
                                            <td className="plan-preview-table-right"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-bl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-bottom"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-br">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>	
                                    </tbody>    
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div id="plan-legend">
                                    <p className="plan-legend-title">Legenda</p>
                                    <p className="legend-number">[<span className="number">04</span>] Numer stoiska</p>

                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: "red"}}>&nbsp;</span> Do wysyłki</p>

                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: "lime"}}>&nbsp;</span> Potwierdzone mailowo</p>

                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: "#00CC00"}}>&nbsp;</span> Potwierdzone telefonicznie</p>

                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: "#0a5c0a"}}>&nbsp;</span> Otrzymał</p>

                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: "yellow"}}>&nbsp;</span> Wysłano</p>

                                    <p className="legend-filar"><span className="filar" style={{backgroundColor: color_wall}}>&nbsp;</span> Filar</p>
                                    <p className="legend-exitplan"><img src="/dist/_img/plan-legend-exitplan.png" alt="" /> Wejście</p>
                                    <br />
                                    <p className="legend-light"><img src="/dist/_img/plan-legend-light.png" alt="" /> Punkt świetlny</p>
                                    <p className="legend-volt"><img src="/dist/_img/plan-legend-volt.png" alt="" /> Gniazdo elektryczne</p>
                                    <p className="legend-any"><img src="/dist/_img/plan-legend-lada.png" alt="" /> lada</p>
                                    <p className="legend-regal"><img src="/dist/_img/plan-legend-regal.png" alt="" /> Regał</p>
                                    <p className="legend-hanger"><img src="/dist/_img/plan-legend-hanger.png" alt="" /> Wieszak</p>
                                    <p className="legend-hoker"><img src="/dist/_img/plan-legend-hoker.png" alt="" /> Hoker</p>
                                    <p className="legend-leaflets"><img src="/dist/_img/plan-legend-leaflets.png" alt="" /> Ulotki</p>
                                    <p className="legend-exit"><img src="/dist/_img/plan-legend-exit.png" alt="" /> Drzwi</p>        
                                </div>    
                            </td>
                        </tr>
                    </tbody>    
                    </table>
                : 
                // Wersja Handlowa :: Pokaż Listę wystawców bez danych na fryz
                (param_l1) && (param_l1 == 't') ?
                    <table className="sbs-download">
                    <tbody>    
                        <tr>
                            <td id="sbs-download-title"><p className="title">{plan_NAME} &nbsp;&nbsp; Data: {plan_DATE}</p></td>
                        </tr>
                        <tr className="none">
                            <td id="sbs-download-content">
                                <div className="sbs-download-div-center">
                                        
                                    <table cellSpacing="0" className="plan-preview-table">
                                    <tbody>    
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-top"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tr">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-left"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                            <td className="plan-preview-table-center">
                                                <table cellSpacing="0" id="plan_CONTENT" style={{width: plan_width*40, height: plan_height*40}}>{parse(plan_CONTENT)}</table>
                                            </td>
                                            <td className="plan-preview-table-right"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-bl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-bottom"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-br">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>
                                    </tbody>    	
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr className="none">
                            <td>
                                <div id="plan-legend">
                                    <p className="plan-legend-title">Legenda</p>
                                    <p className="legend-number">[<span className="number">04</span>] Numer stoiska</p>
                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: color_stand}}>&nbsp;</span> Wykładzina</p>
                                    <p className="legend-stand-own"><span className="stand-own" style={{backgroundColor: "#f1f1f2"}}>&nbsp;</span> Zabudowa własna</p>
                                    <p className="legend-wall"><span className="wall" style={{backgroundColor: color_wall}}>&nbsp;</span> Sciana</p>
                                    <p className="legend-filar"><span className="filar" style={{backgroundColor: color_wall}}>&nbsp;</span> Filar</p>
                                    <p className="legend-exitplan"><img src="/dist/_img/plan-legend-exitplan.png" alt="" /> Wejście</p>
                                    <br />
                                    <p className="legend-light"><img src="/dist/_img/plan-legend-light.png" alt="" /> Punkt świetlny</p>
                                    <p className="legend-volt"><img src="/dist/_img/plan-legend-volt.png" alt="" /> Gniazdo elektryczne</p>
                                    <p className="legend-any"><img src="/dist/_img/plan-legend-lada.png" alt="" /> lada</p>
                                    <p className="legend-regal"><img src="/dist/_img/plan-legend-regal.png" alt="" /> Regał</p>
                                    <p className="legend-hanger"><img src="/dist/_img/plan-legend-hanger.png" alt="" /> Wieszak</p>
                                    <p className="legend-hoker"><img src="/dist/_img/plan-legend-hoker.png" alt="" /> Hoker</p>
                                    <p className="legend-leaflets"><img src="/dist/_img/plan-legend-leaflets.png" alt="" /> Ulotki</p>
                                    <p className="legend-exit"><img src="/dist/_img/plan-legend-exit.png" alt="" /> Drzwi</p>        
                                </div>    
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div id="download-list">
                                    <table className="table-tab" id="list-table">
                                        <thead>
                                            <tr className="header">
                                                <th onClick={(e) => sortTable(e, 0)} className="sort nr"><strong>Nr:</strong></th>
                                                <th onClick={(e) => sortTable(e, 1)} className="sort"><strong>Nazwa:</strong></th>
                                                <th onClick={(e) => sortTable(e, 2)} className="sort"><strong>Powierzchnia:</strong></th>
                                                <th onClick={(e) => sortTable(e, 3)} className="sort size"><strong>m&sup2;</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="empty"><td>&nbsp;</td><td><p className="info">Lista wystawców jest pusta!</p></td><td>&nbsp;</td><td>&nbsp;</td></tr>
                                        </tbody>
                                    </table>                
                                </div>    
                            </td>
                        </tr> 
                    </tbody>                   
                    </table>
                : 
                // Wersja Handlowa :: Pokaż Listę wystawców z danymi na fryz
                (param_l2) && (param_l2 == 't') ?
                    <table className="sbs-download">
                    <tbody>    
                        <tr>
                            <td id="sbs-download-title"><p className="title">{plan_NAME} &nbsp;&nbsp; Data: {plan_DATE}</p></td>
                        </tr>
                        <tr className="none">
                            <td id="sbs-download-content">
                                <div className="sbs-download-div-center">
                                        
                                    <table cellSpacing="0" className="plan-preview-table">
                                    <tbody>    
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-top"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tr">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-left"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                            <td className="plan-preview-table-center">
                                                <table cellSpacing="0" id="plan_CONTENT" style={{width: plan_width*40, height: plan_height*40}}>{parse(plan_CONTENT)}</table>
                                            </td>
                                            <td className="plan-preview-table-right"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-bl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-bottom"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-br">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>	
                                    </tbody>    
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr className="none">
                            <td>
                                <div id="plan-legend">
                                    <p className="plan-legend-title">Legenda</p>
                                    <p className="legend-number">[<span className="number">04</span>] Numer stoiska</p>
                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: color_stand}}>&nbsp;</span> Wykładzina</p>
                                    <p className="legend-stand-own"><span className="stand-own" style={{backgroundColor: "#f1f1f2"}}>&nbsp;</span> Zabudowa własna</p>
                                    <p className="legend-wall"><span className="wall" style={{backgroundColor: color_wall}}>&nbsp;</span> Sciana</p>
                                    <p className="legend-filar"><span className="filar" style={{backgroundColor: color_wall}}>&nbsp;</span> Filar</p>
                                    <p className="legend-exitplan"><img src="/dist/_img/plan-legend-exitplan.png" alt="" /> Wejście</p>
                                    <br />
                                    <p className="legend-light"><img src="/dist/_img/plan-legend-light.png" alt="" /> Punkt świetlny</p>
                                    <p className="legend-volt"><img src="/dist/_img/plan-legend-volt.png" alt="" /> Gniazdo elektryczne</p>
                                    <p className="legend-any"><img src="/dist/_img/plan-legend-lada.png" alt="" /> lada</p>
                                    <p className="legend-regal"><img src="/dist/_img/plan-legend-regal.png" alt="" /> Regał</p>
                                    <p className="legend-hanger"><img src="/dist/_img/plan-legend-hanger.png" alt="" /> Wieszak</p>
                                    <p className="legend-hoker"><img src="/dist/_img/plan-legend-hoker.png'" alt="" /> Hoker</p>
                                    <p className="legend-leaflets"><img src="/dist/_img/plan-legend-leaflets.png" alt="" /> Ulotki</p>
                                    <p className="legend-exit"><img src="/dist/_img/plan-legend-exit.png" alt="" /> Drzwi</p>        
                                </div>    
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div id="download-list">
                                    <table className="table-tab" id="list-table">
                                        <thead>
                                            <tr className="header">
                                                <th onClick={(e) => sortTable(e, 0)} className="sort nr"><strong>Nr:</strong></th>
                                                <th onClick={(e) => sortTable(e, 1)} className="sort"><strong>Nazwa:</strong></th>
                                                <th onClick={(e) => sortTable(e, 2)} className="sort"><strong>Dane na fryz:</strong></th>
                                                <th onClick={(e) => sortTable(e, 3)} className="sort"><strong>Powierzchnia:</strong></th>
                                                <th onClick={(e) => sortTable(e, 4)} className="sort size"><strong>m&sup2;</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="empty"><td>&nbsp;</td><td><p className="info">Lista wystawców jest pusta!</p></td><td>&nbsp;</td><td>&nbsp;</td></tr>
                                        </tbody>
                                    </table>                
                                </div>    
                            </td>
                        </tr> 
                    </tbody>                   
                    </table>
                : 
                // Wersja Handlowa :: Pokaż Listę wystawców z danymi na fryz
                (param_l3) && (param_l3 == 't') ?
                    <table className="sbs-download;table2excel">
                    <tbody>    
                        <tr>
                            <td id="sbs-download-title"><p className="title">{plan_NAME} &nbsp;&nbsp; Data: {plan_DATE}</p></td>
                        </tr>
                        <tr>
                            <td id="sbs-download-excel"><p onClick={getexcel_l3t} >Pobierz plik <strong>Excel</strong></p></td>
                        </tr>                
                        <tr className="none">
                            <td id="sbs-download-content">
                                <div className="sbs-download-div-center">
                                        
                                    <table cellSpacing="0" className="plan-preview-table">
                                    <tbody>    
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-top"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tr">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-left"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                            <td className="plan-preview-table-center">
                                                <table cellSpacing="0" id="plan_CONTENT" style={{width: plan_width*40, height: plan_height*40}}>{parse(plan_CONTENT)}</table>
                                            </td>
                                            <td className="plan-preview-table-right"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-bl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-bottom"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-br">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>	
                                    </tbody>    
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr className="none">
                            <td>
                                <div id="plan-legend">
                                    <p className="plan-legend-title">Legenda</p>
                                    <p className="legend-number">[<span className="number">04</span>] Numer stoiska</p>
                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: color_stand}}>&nbsp;</span> Wykładzina</p>
                                    <p className="legend-stand-own"><span className="stand-own" style={{backgroundColor: "#f1f1f2"}}>&nbsp;</span> Zabudowa własna</p>
                                    <p className="legend-wall"><span className="wall" style={{backgroundColor: color_wall}}>&nbsp;</span> Sciana</p>
                                    <p className="legend-filar"><span className="filar" style={{backgroundColor: color_wall}}>&nbsp;</span> Filar</p>
                                    <p className="legend-exitplan"><img src="/dist/_img/plan-legend-exitplan.png" alt="" /> Wejście</p>
                                    <br />
                                    <p className="legend-light"><img src="/dist/_img/plan-legend-light.png" alt="" /> Punkt świetlny</p>
                                    <p className="legend-volt"><img src="/dist/_img/plan-legend-volt.png" alt="" /> Gniazdo elektryczne</p>
                                    <p className="legend-any"><img src="/dist/_img/plan-legend-lada.png" alt="" /> lada</p>
                                    <p className="legend-regal"><img src="/dist/_img/plan-legend-regal.png" alt="" /> Regał</p>
                                    <p className="legend-hanger"><img src="/dist/_img/plan-legend-hanger.png" alt="" /> Wieszak</p>
                                    <p className="legend-hoker"><img src="/dist/_img/plan-legend-hoker.png" alt="" /> Hoker</p>
                                    <p className="legend-leaflets"><img src="/dist/_img/plan-legend-leaflets.png" alt="" /> Ulotki</p>
                                    <p className="legend-exit"><img src="/dist/_img/plan-legend-exit.png" alt="" /> Drzwi</p>        
                                </div>    
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div id="download-list">
                                    <table className="table-tab" id="list-table">
                                        <thead>
                                            <tr className="header">
                                                <th onClick={(e) => sortTable(e, 0)} className="sort nr"><strong>Nr:</strong></th>
                                                <th onClick={(e) => sortTable(e, 1)} className="sort"><strong>Nazwa:</strong></th>
                                                <th onClick={(e) => sortTable(e, 2)} className="sort"><strong>Dane na fryz:</strong></th>
                                                <th onClick={(e) => sortTable(e, 3)} className="sort"><strong>Powierzchnia:</strong></th>
                                                <th onClick={(e) => sortTable(e, 4)} className="sort size"><strong>m&sup2;</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="empty"><td>&nbsp;</td><td><p className="info">Lista wystawców jest pusta!</p></td><td>&nbsp;</td><td>&nbsp;</td></tr>
                                        </tbody>
                                    </table>                
                                </div>    
                            </td>
                        </tr> 
                    </tbody>                   
                    </table>
                : 
                // Excel :: Informacje techniczne
                (param_l4) && (param_l4 == 't') ?
                    <table className="sbs-download;table2excel">
                    <tbody>    
                        <tr>
                            <td id="sbs-download-title"><p className="title">{plan_NAME} &nbsp;&nbsp; Data: {plan_DATE}</p></td>
                        </tr>
                        <tr>
                            <td id="sbs-download-excel"><p onClick={getexcel_l4t} >Pobierz plik <strong>Excel</strong></p></td>
                        </tr>                
                        <tr className="none">
                            <td id="sbs-download-content">
                                <div className="sbs-download-div-center">
                                        
                                    <table cellSpacing="0" className="plan-preview-table">
                                    <tbody>    
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-top"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tr">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-left"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                            <td className="plan-preview-table-center">
                                                <table cellSpacing="0" id="plan_CONTENT" style={{width: plan_width*40, height: plan_height*40}}>{parse(plan_CONTENT)}</table>
                                            </td>
                                            <td className="plan-preview-table-right"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-bl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-bottom"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-br">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>   
                                    </tbody>    
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr className="none">
                            <td>
                                <div id="plan-legend">
                                    <p className="plan-legend-title">Legenda</p>
                                    <p className="legend-number">[<span className="number">04</span>] Numer stoiska</p>
                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: color_stand}}>&nbsp;</span> Wykładzina</p>
                                    <p className="legend-stand-own"><span className="stand-own" style={{backgroundColor: "#f1f1f2"}}>&nbsp;</span> Zabudowa własna</p>
                                    <p className="legend-wall"><span className="wall" style={{backgroundColor: color_wall}}>&nbsp;</span> Sciana</p>
                                    <p className="legend-filar"><span className="filar" style={{backgroundColor: color_wall}}>&nbsp;</span> Filar</p>
                                    <p className="legend-exitplan"><img src="/dist/_img/plan-legend-exitplan.png" alt="" /> Wejście</p>
                                    <br />
                                    <p className="legend-light"><img src="/dist/_img/plan-legend-light.png" alt="" /> Punkt świetlny</p>
                                    <p className="legend-volt"><img src="/dist/_img/plan-legend-volt.png" alt="" /> Gniazdo elektryczne</p>
                                    <p className="legend-any"><img src="/dist/_img/plan-legend-lada.png" alt="" /> lada</p>
                                    <p className="legend-regal"><img src="/dist/_img/plan-legend-regal.png" alt="" /> Regał</p>
                                    <p className="legend-hanger"><img src="/dist/_img/plan-legend-hanger.png" alt="" /> Wieszak</p>
                                    <p className="legend-hoker"><img src="/dist/_img/plan-legend-hoker.png" alt="" /> Hoker</p>
                                    <p className="legend-leaflets"><img src="/dist/_img/plan-legend-leaflets.png" alt="" /> Ulotki</p>
                                    <p className="legend-exit"><img src="/dist/_img/plan-legend-exit.png" alt="" /> Drzwi</p>        
                                </div>    
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div id="download-list">
                                    <table className="table-tab" id="list-table">
                                        <thead>
                                            <tr className="header">
                                                <th onClick={(e) => sortTable(e, 0)} className="sort nr"><strong>Nr:</strong></th>
                                                <th onClick={(e) => sortTable(e, 1)} className="sort"><strong>Nazwa:</strong></th>
                                                <th onClick={(e) => sortTable(e, 2)} className="sort"><strong>Info tech:</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="empty"><td>&nbsp;</td><td><p className="info">Lista wystawców jest pusta!</p></td><td>&nbsp;</td><td>&nbsp;</td></tr>
                                        </tbody>
                                    </table>                
                                </div>    
                            </td>
                        </tr>  
                    </tbody>                  
                    </table>
                : 
                // Excel :: Dane do zabudowy
                (param_l5) && (param_l5 == 't') ?
                    <table className="sbs-download;table2excel">
                    <tbody>    
                        <tr>
                            <td id="sbs-download-title"><p className="title">{plan_NAME} &nbsp;&nbsp; Data: {plan_DATE}</p></td>
                        </tr>
                        <tr>
                            <td id="sbs-download-excel"><p onClick={getexcel_l5t} >Pobierz plik <strong>Excel</strong></p></td>
                        </tr>                
                        <tr className="none">
                            <td id="sbs-download-content">
                                <div className="sbs-download-div-center">
                                        
                                    <table cellSpacing="0" className="plan-preview-table">
                                    <tbody>    
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-top"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-tr">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-left"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                            <td className="plan-preview-table-center">
                                                <table cellSpacing="0" id="plan_CONTENT" style={{width: plan_width*40, height: plan_height*40}}>{parse(plan_CONTENT)}</table>
                                            </td>
                                            <td className="plan-preview-table-right"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                        </tr>
                                        <tr>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-bl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                            <td className="plan-preview-table-bottom"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                            <td className="plan-preview-table-fix"><div className="number-fix number-fix-br">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                        </tr>   
                                    </tbody>    
                                    </table>
                                </div>
                            </td>
                        </tr>
                        <tr className="none">
                            <td>
                                <div id="plan-legend">
                                    <p className="plan-legend-title">Legenda</p>
                                    <p className="legend-number">[<span className="number">04</span>] Numer stoiska</p>
                                    <p className="legend-stand"><span className="stand" style={{backgroundColor: color_stand}}>&nbsp;</span> Wykładzina</p>
                                    <p className="legend-stand-own"><span className="stand-own" style={{backgroundColor: "#f1f1f2"}}>&nbsp;</span> Zabudowa własna</p>
                                    <p className="legend-wall"><span className="wall" style={{backgroundColor: color_wall}}>&nbsp;</span> Sciana</p>
                                    <p className="legend-filar"><span className="filar" style={{backgroundColor: color_wall}}>&nbsp;</span> Filar</p>
                                    <p className="legend-exitplan"><img src="/dist/_img/plan-legend-exitplan.png" alt="" /> Wejście</p>
                                    <br />
                                    <p className="legend-light"><img src="/dist/_img/plan-legend-light.png" alt="" /> Punkt świetlny</p>
                                    <p className="legend-volt"><img src="/dist/_img/plan-legend-volt.png" alt="" /> Gniazdo elektryczne</p>
                                    <p className="legend-any"><img src="/dist/_img/plan-legend-lada.png" alt="" /> lada</p>
                                    <p className="legend-regal"><img src="/dist/_img/plan-legend-regal.png" alt="" /> Regał</p>
                                    <p className="legend-hanger"><img src="/dist/_img/plan-legend-hanger.png" alt="" /> Wieszak</p>
                                    <p className="legend-hoker"><img src="/dist/_img/plan-legend-hoker.png" alt="" /> Hoker</p>
                                    <p className="legend-leaflets"><img src="/dist/_img/plan-legend-leaflets.png" alt="" /> Ulotki</p>
                                    <p className="legend-exit"><img src="/dist/_img/plan-legend-exit.png" alt="" /> Drzwi</p>        
                                </div>    
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div id="download-list">
                                    <table className="table-tab" id="list-table">
                                        <thead>
                                            <tr className="header">
                                                <th onClick={(e) => sortTable(e, 0)} className="sort nr"><strong>Nr:</strong></th>
                                                <th onClick={(e) => sortTable(e, 1)} className="sort"><strong>Nazwa:</strong></th>
                                                <th onClick={(e) => sortTable(e, 2)} className="sort"><strong>Dodatkowe zamówienia (zabudowa):</strong></th>
                                                <th onClick={(e) => sortTable(e, 3)} className="sort"><strong>Dane na fryz</strong></th>
                                                <th onClick={(e) => sortTable(e, 4)} className="sort"><strong>Powierzchnia</strong></th>
                                                <th onClick={(e) => sortTable(e, 5)} className="sort size"><strong>m&sup2;</strong></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="empty"><td>&nbsp;</td><td><p className="info">Lista wystawców jest pusta!</p></td><td>&nbsp;</td><td>&nbsp;</td></tr>
                                        </tbody>
                                    </table>                
                                </div>    
                            </td>
                        </tr>  
                    </tbody>                  
                    </table>
                : <></> 


            : <></> 
        }

        { (param_v) &&  (param_v=='kt') ? 
                <table className="sbs-download">
                <tbody>    
                    <tr>
                        <td id="sbs-download-title">
                            {(param_lang) &&  (param_lang!='en') ? <p className="kw_title2">KARTA TECHNICZNA WYSTAWCY</p> : <p className="kw_title2">EXHIBITOR'S TECHNICAL SHEET</p>}
                            <p className="kw_title3">{plan_NAME}</p>
                            <br /><br />
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="kw_d1 kw_logo">
                                {(param_lang) &&  (param_lang!='en') ? <p className="kw_text"><strong>Termin Targów:</strong> <span>{tc_fairdate}</span></p> : <p className="kw_text"><strong>Fair date:</strong> <span>{tc_fairdate}</span></p>  }
                                {(param_lang) &&  (param_lang!='en') ? <p className="kw_text"><strong>Nazwa obiektu:</strong> <span>{tc_objectname}</span></p> : <p className="kw_text"><strong>Name of the object:</strong> <span>{tc_objectname}</span></p> }
                                {(param_lang) &&  (param_lang!='en') ? <p className="kw_text"><strong>Adres obiektu:</strong> <span>{tc_objectaddress}</span></p> : <p className="kw_text"><strong>Facility address:</strong> <span>{tc_objectaddress}</span></p>}
                                {(param_lang) &&  (param_lang!='en') ? <p className="kw_text"><strong>Godziny otwarcia dla Zwiedzających:</strong> <span>{tc_visitoropeninghours}</span></p> : <p className="kw_text"><strong>Opening Hours for Visitors:</strong> <span>{tc_visitoropeninghours}</span></p> }
                                {(param_lang) &&  (param_lang!='en') ? <p className="kw_text"><strong>Godziny otwarcia dla Wystawców:</strong> <span>{tc_exhibitoropeninghours}</span></p> :  <p className="kw_text"><strong>Opening hours for Exhibitors:</strong> <span>{tc_exhibitoropeninghours}</span></p> }
                                {(param_lang) &&  (param_lang!='en') ? <p className="kw_text"><strong>Osoba kontaktowa:</strong> <span>{tc_contactperson !='' ? tc_contactperson : 'Joanna Arabska 792 772 230 organizacja@expoproperty.pl'}</span></p> : <p className="kw_text"><strong>Contact person:</strong> <span>{tc_contactperson !=''? tc_contactperson : 'Joanna Arabska 792 772 230 organizacja@expoproperty.pl'}</span></p> }
                                {(param_lang) &&  (param_lang!='en') ? <p className="kw_text none"><strong>Status wysłania karty technicznej:</strong> <span id="kwdsm">&nbsp;</span></p> : <p className="kw_text none"><strong>Status of technical card submission:</strong> <span id="kwdsm">&nbsp;</span></p> }
                                {(param_lang) &&  (param_lang!='en') ? <p className="kw_title4 printit"><strong>Pobierz w PDF</strong></p> : <p className="kw_title4 printit"><strong>Download in PDF</strong></p> }

                                
                            </div>
                            
                            <div className="kw_d1">
                                {/*w przypadku powierzchni zabudowanej */}
                                
                                <div className="kw_1">
                                    {(param_lang) &&  (param_lang!='en') ?  <p className="kw_title4"><strong><span>1.</span> Wizualizacja i wyposażenie powierzchni:</strong> zabudowanej &nbsp;&nbsp;<strong><span className="kw_1_nr">Numer stoiska: x</span></strong></p> : <p className="kw_title4"><strong><span>1.</span> Visualisation and furnishing of the built-up area:</strong> &nbsp;&nbsp;<strong><span className="kw_1_nr">Stand number: x</span></strong></p>}
                                    {(param_lang) &&  (param_lang!='en') ?  <p className="kw_text" style={{marginLeft: 18}}><strong>Nazwa w Spisie:</strong> <span className="kw_1_nws">-</span></p> :  <p className="kw_text" style={{marginLeft: 18}}><strong>Name in the Directory:</strong> <span className="kw_1_nws">-</span></p> }
                                    {(param_lang) &&  (param_lang!='en') ?  <p className="kw_text" style={{marginLeft: 18}}><strong>Dane na fryz:</strong> <span className="kw_1_dnf">-</span></p> : <p className="kw_text" style={{marginLeft: 18}}><strong>Data for frieze:</strong> <span className="kw_1_dnf">-</span></p> } 
                                    
                                </div>
                                { /* w przypadku powierzchni niezabudowanej */}
                                <div className="kw_2">
                                    {(param_lang) &&  (param_lang!='en') ? <p className="kw_title4"><strong><span>1.</span> Wizualizacja i wyposażenie powierzchni:</strong> niezabudowanej &nbsp;&nbsp;<strong><span className="kw_2_nr">Numer stoiska: x</span></strong></p> : <p className="kw_title4"><strong><span>1.</span> Visualisation and equipment of the unbuilt area:</strong> &nbsp;&nbsp;<strong><span className="kw_2_nr">Stand number: x</span></strong></p> }
                                    {(param_lang) &&  (param_lang!='en') ? <p className="kw_text" style={{marginLeft: 18}}><strong>Nazwa w Spisie:</strong> <span className="kw_1_nws">-</span></p> : <p className="kw_text" style={{marginLeft: 18}}><strong>Name in the Directory:</strong> <span className="kw_1_nws">-</span></p> }
                                    {(param_lang) &&  (param_lang!='en') ? <p className="kw_text" style={{marginLeft: 18}}><strong>Dane na fryz:</strong> <span className="kw_1_dnf">-</span></p> : <p className="kw_text" style={{marginLeft: 18}}><strong>Data for frieze:</strong> <span className="kw_1_dnf">-</span></p> }
                                    
                                </div>
                            </div>
                            
                            {(param_lang) &&  (param_lang!='en') ? <div className="download-stoisko_d"><div className="download-stoisko">Stoisko</div></div> :  <div className="download-stoisko_d"><div className="download-stoisko">Stand</div></div> }
                            
                            <div className="kw_d2">
                                { /*w przypadku powierzchni zabudowanej */ }
                                <div className="kw_1" style={{marginLeft: 18}}>
                                    {(param_lang) &&  (param_lang!='en') ? <p className="kw_text"><strong>Odbiór i aranżacja stoiska:</strong> <span>{tc_checkingdate}</span></p> : <p className="kw_text"><strong>Acceptance and arrangement of the stand:</strong> <span>{tc_checkingdate}</span></p> }
                                    {note1!=''? <><br /> {(param_lang) &&  (param_lang!='en') ? <p className="kw_text"><strong>Uwaga 1:</strong>{parse(note1.replace(/(?:\r\n|\r|\n)/g, '<br>'))}</p> : <p className="kw_text"><strong>Note 1:</strong>{parse(note1.replace(/(?:\r\n|\r|\n)/g, '<br>'))}</p> }</> : ''}
                                    {note2!=''? <><br /> {(param_lang) &&  (param_lang!='en') ? <p className="kw_text"><strong>Uwaga 2:</strong>{parse(note2.replace(/(?:\r\n|\r|\n)/g, '<br>'))}</p> : <p className="kw_text"><strong>Note 2:</strong>{parse(note2.replace(/(?:\r\n|\r|\n)/g, '<br>'))}</p> }</> : ''}
                                </div>
                                {/* w przypadku powierzchni niezabudowanej*/}
                                <div className="kw_2" style={{marginLeft: 18}}>
                                    {(param_lang) &&  (param_lang!='en') ? <p className="kw_text"><strong>Montaż i zabudowa stoiska:</strong> <span>{tc_constructiondate}</span></p> :  <p className="kw_text"><strong>Stand assembly and construction:</strong> <span>{tc_constructiondate}</span></p> } 
                                </div>                    
                            </div>                    
                            <div className="kw_d1">
                                <p className="kw_title4">
                                    {(param_lang) &&  (param_lang!='en') ? <strong><span>2.</span> Grafika na stoisko:</strong> :  <strong><span>2.</span> Graphics for the stand:</strong> }
                                    {(param_lang) &&  (param_lang!='en') ? <span style={{color: "#000000"}} id="kw_info_3">dotyczy/nie dotyczy WYSTAWCY</span> : <span style={{color: "#000000"}} id="kw_info_3">applicable/not applicable EXHIBITOR</span> }
                                </p>
                                {(param_lang) &&  (param_lang!='en') ? <p className="kw_text gfx-not-linked"><strong style={{marginLeft: 18}}>Data dostarczania materiałów do składowych:</strong>{parse(tc_componentgraphicsdate.replace(/(?:\r\n|\r|\n)/g, '<br>'))}</p> : <p className="kw_text gfx-not-linked"><strong style={{marginLeft: 18}}>Date of delivery of materials to depots:</strong>{parse(tc_componentgraphicsdate.replace(/(?:\r\n|\r|\n)/g, '<br>'))}</p>}
                                {(param_lang) &&  (param_lang!='en') ? <p className="kw_text gfx-not-linked"><strong style={{marginLeft: 18}}>Data dostarczania gotowych plików produkcyjnych:</strong>{parse(tc_readygraphicsdate.replace(/(?:\r\n|\r|\n)/g, '<br>'))}</p> : <p className="kw_text gfx-not-linked"><strong style={{marginLeft: 18}}>Date of delivery of finished production files:</strong>{parse(tc_readygraphicsdate.replace(/(?:\r\n|\r|\n)/g, '<br>'))}</p> }
                                <div id="kw_info_4"></div>
                            </div>

                            <div className="kw_d1">
                                {(param_lang) &&  (param_lang!='en') ? <p className="kw_title4"><strong><span>3.</span> Pozostałe ustalenia z Klientem:</strong></p> :  <p className="kw_title4"><strong><span>3.</span> Other arrangements with the client:</strong></p> }
                                {(param_lang) &&  (param_lang!='en') ? <p className="kw_text" style={{marginLeft: 18}}><strong>Realizowane przez firmę od zabudowy Targów:</strong> <span id="kw_info_1">...</span></p> : <p className="kw_text" style={{marginLeft: 18}}><strong>The company's realisation from the development of the Fair:</strong> <span id="kw_info_1">...</span></p> }
                                {(param_lang) &&  (param_lang!='en') ? <p className="kw_text" style={{marginLeft: 18}}><strong>Realizowane przez Organizatora Targów:</strong> <span id="kw_info_2">...</span></p> : <p className="kw_text" style={{marginLeft: 18}}><strong>Carried out by the trade fair organiser:</strong> <span id="kw_info_2">...</span></p> }
                            </div>
            
                                <div className="kw_d1">
                                    <div className="kw_2">
                                    {(param_lang) &&  (param_lang!='en') ? <p className="kw_title4"><strong><span>4.</span>  Demontaż stoisk niezabudowanych:</strong> 
                                    {parse(tc_disassemblystand.replace(/(?:\r\n|\r|\n)/g, '<br>'))}</p> :  <p className="kw_title4"><strong><span>4.</span>  Dismantling of unbuilt stands:</strong> 
                                    {parse(tc_disassemblystand.replace(/(?:\r\n|\r|\n)/g, '<br>'))}</p>  }
                                    
                                    </div>
                                    <div className="kw_1">
                                     {(param_lang) &&  (param_lang!='en') ? <p className="kw_title4"><strong><span>4.</span>  Opuszczenie stoisk zabudowanych:</strong> 
                                    {parse(tc_disassemblybuiltstand.replace(/(?:\r\n|\r|\n)/g, '<br>'))}</p> : <p className="kw_title4"><strong><span>4.</span>  Leaving built-up stands:</strong> 
                                    {parse(tc_disassemblybuiltstand.replace(/(?:\r\n|\r|\n)/g, '<br>'))}</p> }
                                    </div>
                                </div>

                            
                            <div className="kw_d1">
                                {(param_lang) &&  (param_lang!='en') ?  <p className="kw_title4"><strong><span>5.</span>  Zasady parkowania:</strong>{parse(parkrules.replace(/(?:\r\n|\r|\n)/g, '<br>'))}</p> : <p className="kw_title4"><strong><span>5.</span>  Parking rules:</strong>{parse(parkrules.replace(/(?:\r\n|\r|\n)/g, '<br>'))}</p> }
                            </div>
                            <div className="kw_d1">
                                {(param_lang) &&  (param_lang!='en') ?  <p className="kw_title4"><strong><span>6.</span> Pozostałe uwagi:</strong></p> : <p className="kw_title4"><strong><span>6.</span> Other comments:</strong></p> }
                                <p className="kw_text" style={{marginLeft: 18}}><span>{parse(tc_othercomments.replace(/(?:\r\n|\r|\n)/g, '<br>'))}</span></p>
                            </div>
                            <div className="kw_d1" id="planT">
                                 {(param_lang) &&  (param_lang!='en') ? <p className="kw_title4"><strong><span>6.</span> Plan stoisk </strong></p> : <p className="kw_title4"><strong><span>6.</span> Stand plan</strong></p> }
                            </div>
                            <div className="kw_d1 kw_img_place">
                                 {(param_lang) &&  (param_lang!='en') ? <p className="kw_title4"><strong><span>7.</span> PLAN WJAZDU NA PARKING DLA WYSTAWCÓW:</strong></p> :  <p className="kw_title4"><strong><span>7.</span> ENTRY PLAN FOR THE EXHIBITORS' CAR PARK:</strong></p>  }
                                
                                <div>
                        {tc_parkmapimage && (
                          <div style={{ marginTop: 50, display: "flex", flexDirection: "column"}}>
                            <img
                              
                              src={parkmapimageURL}
                              alt={tc_parkmapimage.substring(tc_parkmapimage.lastIndexOf('/')+1)}
                             
                            />
                        
                          </div>
                        )}
                        </div>

                                
                            </div>
                            
                            <div className="deliver-accept none">
                                <div className="inner">
                                     {(param_lang) &&  (param_lang!='en') ?  <h4>Otrzymałem Kartę Techniczną Wystawcy</h4> :  <h4>I have received the Technical Exhibitor Card</h4> }
                                    {(param_lang) &&  (param_lang!='en') ?  <button type="button">Potwierdzam</button> : <button type="button">Confirm</button> }
                                    {(param_lang) &&  (param_lang!='en') ? <a href="mailto:jw@expoproperty.pl">Zgłoś problem</a> : <a href="mailto:jw@expoproperty.pl">Report a problem</a> }
                                </div>
                            </div>

                        </td>
                    </tr>
                    <tr>
                        <td id="sbs-download-content">
                            <div className="sbs-download-div-center" style={{marginLeft: -30}}>
                                    
                                <table cellSpacing="0" className="plan-preview-table">
                                    <tr>
                                        <td className="plan-preview-table-fix"><div className="number-fix number-fix-tl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                        <td className="plan-preview-table-top"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                        <td className="plan-preview-table-fix"><div className="number-fix number-fix-tr">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                    </tr>
                                    <tr>
                                        <td className="plan-preview-table-left"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                        <td className="plan-preview-table-center">
                                            <table cellSpacing="0" id="plan_CONTENT" style={{width: plan_width*40, height: plan_height*40}}>{parse(plan_CONTENT)}</table>
                                        </td>
                                        <td className="plan-preview-table-right"><div className="number-vertical">{parse(numberVertical)}</div></td>
                                    </tr>
                                    <tr>
                                        <td className="plan-preview-table-fix"><div className="number-fix number-fix-bl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                                        <td className="plan-preview-table-bottom"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                                        <td className="plan-preview-table-fix"><div className="number-fix number-fix-br">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                                    </tr>	
                                </table>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div id="plan-legend" style={{marginLeft: -70}}>
                                <p className="legend-number">[<span className="number">04</span>] Numer stoiska</p>
                                <p className="legend-stand"><span className="stand" style={{backgroundColor: color_stand}}>&nbsp;</span> Wykładzina</p>
                                <p className="legend-stand-own"><span className="stand-own" style={{backgroundColor: "#f1f1f2"}}>&nbsp;</span> Zabudowa własna</p>
                                <p className="legend-wall"><span className="wall" style={{backgroundColor: color_wall}}>&nbsp;</span> Sciana</p>
                                <p className="legend-filar"><span className="filar" style={{backgroundColor: color_wall}}>&nbsp;</span> Filar</p>
                                <p className="legend-exitplan"><img src="/dist/_img/plan-legend-exitplan.png" alt="" /> Wejście</p>
                                <br />
                                <p className="legend-light"><img src="/dist/_img/plan-legend-light.png" alt="" /> Punkt świetlny</p>
                                <p className="legend-volt"><img src="/dist/_img/plan-legend-volt.png" alt="" /> Gniazdo elektryczne</p>
                                <p className="legend-any"><img src="/dist/_img/plan-legend-lada.png" alt="" /> lada</p>
                                <p className="legend-regal"><img src="/dist/_img/plan-legend-regal.png" alt="" /> Regał</p>
                                <p className="legend-hanger"><img src="/dist/_img/plan-legend-hanger.png" alt="" /> Wieszak</p>
                                <p className="legend-hoker"><img src="/dist/_img/plan-legend-hoker.png" alt="" /> Hoker</p>
                                <p className="legend-leaflets"><img src="/dist/_img/plan-legend-leaflets.png" alt="" /> Ulotki</p>
                                <p className="legend-exit"><img src="/dist/_img/plan-legend-exit.png" alt="" /> Drzwi</p>        
                            </div>    
                        </td>
                    </tr>
                </tbody>    
                </table>
            : <></> 
        } 
    </section>
  )
 
}
export default Cardview;

function zamienGodziny(temp_DATA2: string | undefined) {
    throw new Error("Function not implemented.");
}

